import { useEffect, useState, useLayoutEffect, useRef } from "react";
import {
  Navigate,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import { useSelector } from "react-redux";
import InputMask from "react-input-mask";
import firebase, { storage } from "../../config/firebase";
import { format } from "date-fns";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import PasswordInput from "../../components/PasswordInput/passwordInput";
import AlertDialog from "../../components/dialog";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Autocomplete,
  Snackbar,
  TextField,
} from "@mui/material";
import {
  sendPasswordResetEmail,
  getAuth,
  EmailAuthProvider,
  reauthenticateWithCredential,
  updatePassword,
} from "firebase/auth";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Layout,
  Card,
  Row,
  Col,
  Tabs,
  Avatar,
  Rate,
  Typography,
  Radio,
  Button,
  Tooltip,
  Spin,
} from "antd";
import { Card as Cards } from "@mui/material";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import Utils from "../../util/utils";
import paymentService from "../../service/payment.service";
import driverService from "../../service/driver.service";
import shipperService from "../../service/shipper.service";

const { Header, Content, Footer } = Layout;
const { TabPane } = Tabs;
const { Title } = Typography;

require("firebase/auth");

const auth = getAuth(firebase);

const SHIPPER_LINK_NOTICE_MESSAGE =
  "Este motorista ainda não está vinculado ao seu embarcador. Ao atualizar o cadastro, ele será vinculado automaticamente ao seu embarcador.";

function Driver() {
  const { id } = useParams();

  const location = useLocation();

  // Listas de UseStates
  const [view, setView] = useState(location.state?.viewOnly || false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [erroForm, setErroForm] = useState({});
  const [tipo, setTipo] = useState("");

  const [erro, setErro] = useState("");

  const [carregando, setCarregando] = useState(id ? 1 : 0);
  const [totalDocuments, setTotalDocuments] = useState("");
  const [totalFinalized, setTotalFinalized] = useState(0);

  const [status, setStatus] = useState("authorized");
  const [name, setName] = useState("");

  const [created, setCreated] = useState("");
  const [lastUpdated, setLastUpdated] = useState("");
  const [birthDate, setBirthDate] = useState();
  const [documentCnhExpiration, setDocumentCnhExpiration] = useState("");
  const [documentCnh, setDocumentCnh] = useState("");
  const [lastUpdatedBackOffice, setLastUpdatedBackOffice] = useState("");

  //Address
  const [cep, setCep] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [street, setStreet] = useState("");
  const [comprovanteEndereco, setComprovanteEndereco] = useState(null);
  const [complementoEndereco, setComplementoEndereco] = useState("");

  //dataBank
  const [accountDigit, setAccountDigit] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [agency, setAgency] = useState("");
  const [bankName, setBankName] = useState("");
  const [code, setCode] = useState("");
  const [holderAccount, setHolderAccount] = useState("");
  const [ispb, setIspb] = useState("");
  const [pix, setPix] = useState("");

  //kinships
  const [contactKinships1, setContactKinships1] = useState("");
  const [degreeKinships1, setDegreeKinships1] = useState("");
  const [nameKinships1, setNameKinships1] = useState("");
  const [contactKinships2, setContactKinships2] = useState("");
  const [degreeKinships2, setDegreeKinships2] = useState("");
  const [nameKinships2, setNameKinships2] = useState("");
  //PersonalData

  const [contact, setContact] = useState("");
  const [documentAnttFrontImg, setDocumentAnttFrontImg] = useState(null);
  const [documentCRLV, setdocumentCRLV] = useState(null);
  const [documentCnhFrontImg, setDocumentCnhFrontImg] = useState(null);
  const [cnhReboque, setcnhReboque] = useState(null);
  const [fullName, setFullName] = useState("");
  const [sexGender, setSexGender] = useState("");
  const [anttReboque, setanttReboque] = useState(null);

  //ProfessionalRerence
  const [contactProfessional, setContactProfessional] = useState("");
  const [nameProfessional, setNameProfessional] = useState("");
  const [contactProfessional1, setContactProfessional1] = useState("");
  const [nameProfessional1, setNameProfessional1] = useState("");

  // vehicle
  const [bodyworkPlate, setBodyworkPlate] = useState("");
  const [bodyworkType, setBodyworkType] = useState("");
  const [vehicleImg, setVehicleImg] = useState(null);
  const [vehiclePlate, setVehiclePlate] = useState("");
  const [vehicleType, setVehicleType] = useState("");

  const [renavam, setRenavam] = useState("");
  const [ufVeiculo, setUfVeiculo] = useState("");
  const [descricaoVeiculo, setDescricaoVeiculo] = useState("");
  const [rntrc, setRntrc] = useState("");
  const [tipoRNTRC, setTipoRNTRC] = useState("");
  const [pesoTara, setPesoTara] = useState("");
  const [capacidadeKG, setCapacidadeKG] = useState("");
  const [capacidadeM3, setCapacidadeM3] = useState("");
  const [tipoProprietario, setTipoProprietario] = useState("");
  const [cpfoucnpj, setCpfouCnpj] = useState("");
  const [nomeProprietario, setNomeProprietario] = useState("");
  const [veiculoProprio, setVeiculoProprio] = useState(false);

  const [erroNomeCpfIgual, setErroNomeCpfIgual] = useState(false);
  const [showPerguntaVeiculoProprio, setShowPerguntaVeiculoProprio] =
    useState(false);

  const [cpf, setCpf] = useState();
  const [verifyCpf, setVerifyCpf] = useState([]);
  const [email, setEmail] = useState();
  const [profilePicture, setProfilePicture] = useState();
  const [dateRenovation, setDateRenovation] = useState();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");

  const [passwordTouched, setPasswordTouched] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const [msgTipo, setMsgTipo] = useState();
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();

  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [origem, setOrigem] = useState("");

  const [reboques, setReboques] = useState([createReboque()]);
  const [contacts, setContacts] = useState([createContact()]);
  const [contactsProfessional, setContactsProfessional] = useState([
    createContactProfessional(),
  ]);

  const [disabledList, setDisabledList] = useState(false);

  const [erroMensagem, setErroMensagem] = useState("");

  const [driverIdbyCPF, setDriverIDbyCpf] = useState("");

  const [showInlineShipperLinkNotice, setShowInlineShipperLinkNotice] =
    useState(false);
  const [shipperLinkSnackbar, setShipperLinkSnackbar] = useState({
    open: false,
    message: "",
  });
  const shipperLinkNoticeShownForDriverRef = useRef(null);

  const [persistedShipper, setPersistedShipper] = useState(null);

  const [defaultUIDS, setDefaultUIDS] = useState(null);

  const [shipperDefault, setShipperDefault] = useState(null);

  const [proprietario, setProprietario] = useState({
    tipo: "",
    cpfCnpj: "",
    nome: "",
    erroMensagem: "",
    erroNomeIgual: false,
  });

  //Lista de useSelectors
  const users = useSelector((state) => state.user);
  const shippers = useSelector((state) => state.shipper);

  // Grupos
  const [groups, setGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]); // Array de IDs
  const [selectedGroupsObjects, setSelectedGroupsObjects] = useState([]); // Array de objetos para o Autocomplete

  const db = firebase.firestore();

  let navigate = useNavigate();

  const showShipperLinkNotice = (driverId) => {
    if (shipperLinkNoticeShownForDriverRef.current === driverId) {
      return;
    }
    shipperLinkNoticeShownForDriverRef.current = driverId;
    setShowInlineShipperLinkNotice(true);
    setShipperLinkSnackbar({
      open: true,
      message: SHIPPER_LINK_NOTICE_MESSAGE,
    });
  };

  const clearShipperLinkNotice = () => {
    shipperLinkNoticeShownForDriverRef.current = null;
    setShowInlineShipperLinkNotice(false);
    setShipperLinkSnackbar({ open: false, message: "" });
  };

  // Listas de Constantes e Variaveis
  const listDisabled = [
    "CARRETA S",
    "CARRETA LS",
    "BITREM",
    "RODOTREM",
    "VANDERLEIA",
  ];
  const statesUF = [
    { value: "AC", label: "Acre" },
    { value: "AL", label: "Alagoas" },
    { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" },
    { value: "BA", label: "Bahia" },
    { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" },
    { value: "ES", label: "Espírito Santo" },
    { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" },
    { value: "MT", label: "Mato Grosso" },
    { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" },
    { value: "PA", label: "Pará" },
    { value: "PB", label: "Paraíba" },
    { value: "PR", label: "Paraná" },
    { value: "PE", label: "Pernambuco" },
    { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" },
    { value: "RN", label: "Rio Grande do Norte" },
    { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" },
    { value: "RR", label: "Roraima" },
    { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" },
    { value: "SE", label: "Sergipe" },
    { value: "TO", label: "Tocantins" },
  ];
  var campos = [
    "fullName",
    "cpf",
    "password",
    "confirmPassword",
    "contact",
    "formOfPayment",
    "email",
    "documentCnhExpiration",
  ];
  for (var i = 0; i < campos.length; i++) {
    var campo = document.getElementById(campos[i]);
    if (campo) {
      campo.addEventListener("input", function () {
        this.style.borderColor = "";
      });
    }
  }

  // Lista dos UseEffects

  useEffect(() => {
    const unsubscribe = db
      .collection("tb_group")
      .orderBy("name")
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setGroups(data);
        },
        (error) => {
          console.error("Erro ao buscar grupos:", error);
        }
      );

    return () => unsubscribe();
  }, []);

  // UseEffect para sincronizar selectedGroupsObjects com selectedGroups
  useEffect(() => {
    if (groups.length > 0 && selectedGroups.length > 0) {
      const selectedObjects = selectedGroups
        .map((groupId) => groups.find((g) => g.id === groupId))
        .filter((g) => g !== undefined);
      setSelectedGroupsObjects(selectedObjects);
    } else {
      setSelectedGroupsObjects([]);
    }
  }, [selectedGroups, groups]);

  // UseEffect Principal
  useEffect(() => {
    db.collection("drivers_users")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const driver = doc.data();
          setVerifyCpf((prev) => [...prev, driver.cpf]);
        });
      })
      .catch((error) => {
        console.error("Erro ao buscar drivers:", error);
      });

    if (id) {
      db.collection("drivers_users")
        .doc(id)
        .get()
        .then((result) => {
          var driver = result.data();

          setStatus(driver?.statusDriver);
          setEmail(driver?.email);
          setProfilePicture(driver?.profilePicture);
          setCpf(driver?.cpf);

          setName(driver?.name);

          // Carregar grupos do motorista
          if (driver?.groups && Array.isArray(driver.groups)) {
            setSelectedGroups(driver.groups);
          }
        });

      db.collection("drivers_users")
        .doc(id)
        .collection("documents")
        .doc("allData")
        .get()
        .then(async (result) => {
          var allData = result.data();

          let birthDate = allData?.birthDate;
          let created = allData?.created;
          let lastUpdated = allData?.lastUpdated;
          let personalData = allData?.personalData;
          let dataBank = allData?.dataBank;
          let dataCnhExpiration = allData?.documentCnhExpiration;
          let kinships = allData?.kinships;
          let profissionalReference = allData?.professionalReference;
          let vehicle = allData?.vehicle;
          let address = allData?.address;
          let lastUpdatedBackOffice = allData?.lastUpdatedBackOffice;
          let dateRenovation = allData?.dateRenovation;
          let documentCnh = allData?.documentCnh;

          let dataCreated = created
            ? format(new Date(created.seconds * 1000), "yyyy-MM-dd")
            : "";
          let dataLastUpdate = lastUpdated
            ? format(new Date(lastUpdated.seconds * 1000), "yyyy-MM-dd")
            : "";
          let dataCnhExpired = dataCnhExpiration
            ? format(new Date(dataCnhExpiration.seconds * 1000), "yyyy-MM-dd")
            : "";
          let dataBirthDay = birthDate
            ? format(new Date(birthDate.seconds * 1000), "yyyy-MM-dd")
            : "";
          let dataLastUpdateBack = lastUpdatedBackOffice
            ? format(
              new Date(lastUpdatedBackOffice.seconds * 1000),
              "yyyy-MM-dd"
            )
            : "";
          let dateRenovationParse = dateRenovation
            ? format(new Date(dateRenovation.seconds * 1000), "yyyy-MM-dd")
            : "";

          setPersistedShipper(allData?.shipper);

          if (users?.uidShipper) {
            driverService
              .isDriverLinkedToUserShipper(id, users.uidShipper)
              .then((isLinked) => {
                if (!isLinked) {
                  showShipperLinkNotice(id);
                }
              })
              .catch((error) => {
                console.error(
                  "Error checking driver shipper link:",
                  error
                );
              });
          }

          setBirthDate(dataBirthDay);
          // setCreated(dataCreated)
          setLastUpdated(dataLastUpdate);
          setLastUpdatedBackOffice(dataLastUpdateBack);
          setDateRenovation(dateRenovationParse);

          //Personal data
          setContact(personalData?.contact);
          if (personalData?.documentAnttFrontImg) {
            setDocumentAnttFrontImg(
              personalData?.documentAnttFrontImg != undefined
                ? personalData?.documentAnttFrontImg
                : ""
            );
          }
          if (personalData?.documentCRLV) {
            setdocumentCRLV(
              personalData?.documentCRLV != undefined
                ? personalData?.documentCRLV
                : ""
            );
          }
          if (personalData?.documentCnhFrontImg) {
            setDocumentCnhFrontImg(
              personalData?.documentCnhFrontImg != undefined
                ? personalData?.documentCnhFrontImg
                : ""
            );
          }
          if (personalData?.cnhReboque) {
            setcnhReboque(
              personalData?.cnhReboque != undefined
                ? personalData?.cnhReboque
                : ""
            );
          }
          if (personalData?.anttReboque) {
            setanttReboque(
              personalData?.anttReboque != undefined
                ? personalData?.anttReboque
                : ""
            );
          }

          setFullName(personalData?.fullName);
          setSexGender(personalData?.sexGender);
          setDocumentCnhExpiration(dataCnhExpired);
          setDocumentCnh(personalData?.documentCnh);

          //Vehicle
          setBodyworkPlate(vehicle?.bodyworkPlate);
          setBodyworkType(vehicle?.bodyworkType);
          setVehicleImg(vehicle?.vehicleImg);
          setVehiclePlate(vehicle?.vehiclePlate);
          setVehicleType(vehicle?.vehicleType);

          setRenavam(vehicle?.renavam);
          setUfVeiculo(vehicle?.ufVeiculo);
          setDescricaoVeiculo(vehicle?.descricaoVeiculo);
          setRntrc(vehicle?.rntrc);
          setTipoRNTRC(vehicle?.tipoRNTRC);
          setPesoTara(vehicle?.pesoTara);
          setCapacidadeKG(vehicle?.capacidadeKG);
          setCapacidadeM3(vehicle?.capacidadeM3);
          setProprietario((prev) => ({
            ...prev,
            tipo: vehicle?.tipoProprietario,
          }));
          setProprietario((prev) => ({
            ...prev,
            cpfCnpj: vehicle?.cpfoucnpj,
          }));
          setProprietario((prev) => ({
            ...prev,
            nome: vehicle?.nomeProprietario,
          }));
          setVeiculoProprio(vehicle?.veiculoProprio);

          if (vehicle?.reboques && Array.isArray(vehicle.reboques)) {
            setReboques(vehicle?.reboques);
          }

          //address
          setCep(address?.cep);
          setCity(address?.city);
          setDistrict(address?.district);
          setNumber(address?.number);
          setState(address?.state);
          setStreet(address?.street);
          setComprovanteEndereco(address?.comprovanteEndereco);
          setComplementoEndereco(address?.complementoEndereco);

          //professionalData
          setContactProfessional(profissionalReference[0]?.contact);
          setNameProfessional(profissionalReference[0]?.name);

          setContactProfessional1(profissionalReference[1].contact);
          setNameProfessional1(profissionalReference[1].name);

          if (
            profissionalReference[2]?.contactsProfessional &&
            Array.isArray(profissionalReference[2]?.contactsProfessional)
          ) {
            setContactsProfessional(
              profissionalReference[2]?.contactsProfessional
            );
          }

          //kinships
          setContactKinships1(kinships[0].contact);
          setDegreeKinships1(kinships[0].degree);
          setNameKinships1(kinships[0].name);

          setContactKinships2(kinships[1].contact);
          setDegreeKinships2(kinships[1].degree);
          setNameKinships2(kinships[1].name);

          if (kinships[2]?.contacts && Array.isArray(kinships[2]?.contacts)) {
            setContacts(kinships[2]?.contacts);
          }

          //dataBank
          setAccountDigit(dataBank.accountDigit);
          setAccountNumber(dataBank.accountNumber);
          setAgency(dataBank.agency);
          setBankName(dataBank.bankName);
          setCode(dataBank.code);
          setHolderAccount(dataBank.holderAccount);
          setIspb(dataBank.ispb);
          setPix(dataBank.pix);

          try {
            /* Quantidade de viagens */
            const result = await db.collection("freight").get();
            if (!result.empty) {
              const freights = result.docs.reduce((acc, doc) => {
                const data = doc.data();
                const uidDriver = data?.freight?.getDriverFreight?.uidDriver;
                if (uidDriver === id) {
                  acc.push({
                    id: doc.id,
                    ...data,
                  });
                }
                return acc;
              }, []);
              setTotalDocuments(freights?.length);
            } else {
              console.error("Nenhum frete encontrado para o uidDriver:", id);
            }
          } catch (error) {
            console.error("Erro na busca do frete: " + error);
          }

          try {
            /* Entregas efetuadas */
            const result = await db.collection("freight").get();
            if (!result.empty) {
              const freights = result.docs.reduce((acc, doc) => {
                const data = doc.data();
                const uidDriver = data?.freight?.getDriverFreight?.uidDriver;
                if (uidDriver === id) {
                  acc.push({
                    id: doc.id,
                    ...data,
                  });
                }
                return acc;
              }, []);

              let totalDateOperation = 0;
              await Promise.all(
                // Processar os fretes e calcular os date_operation
                freights.map(async (freight) => {
                  const stoppingPointsSnapshot = await db
                    .collection("freight")
                    .doc(freight.id)
                    .collection("stopping_points")
                    .get();
                  if (!stoppingPointsSnapshot.empty) {
                    stoppingPointsSnapshot.forEach((doc) => {
                      const data = doc.data();
                      if (data?.date_operation) {
                        totalDateOperation += 1;
                      }
                    });
                  }
                })
              );
              setTotalFinalized(totalDateOperation);
            } else {
              console.error("Nenhum frete encontrado para o uidDriver:", id);
            }
          } catch (error) {
            console.error("Erro na busca do frete: " + error);
          }

          setCarregando(0);
        })
        .catch((error) => {
          setCarregando(0);
          console.error(error);
        });
    }
  }, [carregando, id]);

  // Atualiza os reboques quando veiculoProprio, fullName ou cpf mudam
  useEffect(() => {
    let hasChanged = false;

    // Só atualiza reboques se necessário
    setReboques((prevReboques) => {
      if (!Array.isArray(prevReboques)) return prevReboques;
      const novosReboques = prevReboques.map((reboque) => {
        if (reboque.veiculoProprioReboque === true) {
          const atualizado = {
            ...reboque,
            nomeProprietarioReboque: fullName || "",
            cpfoucnpjReboque: formatMask(cpf) || "",
            tipoProprietarioReboque: "cpf",
          };
          if (
            reboque.nomeProprietarioReboque !==
            atualizado.nomeProprietarioReboque ||
            reboque.cpfoucnpjReboque !== atualizado.cpfoucnpjReboque ||
            reboque.tipoProprietarioReboque !==
            atualizado.tipoProprietarioReboque
          ) {
            hasChanged = true;
            return atualizado;
          }
          return reboque;
        } else {
          return reboque;
        }
      });
      return hasChanged ? novosReboques : prevReboques;
    });
  }, [reboques, fullName, cpf, veiculoProprio]);

  // Validações de nome e CPF do proprietário
  useEffect(() => {

    const cpfWithoutMask = withoutMaskCPF(cpf);
    const isCpfValid = Boolean(cpf) && validateCpf(cpf);
    const isCpfAlreadyRegistered =
      isCpfValid && verifyCpf.includes(cpfWithoutMask);

    if (!isCpfValid) {
      clearShipperLinkNotice();
      setErroForm((prev) => ({
        ...prev,
        cpf: {
          hasError: Boolean(cpf),
          message: cpf ? "Esse CPF é inválido!" : "",
        },
        cpfCreate: { hasError: false, message: "" },
      }));
    } else if (isCpfAlreadyRegistered) {
      setErroForm((prev) => ({
        ...prev,
        cpf: { hasError: false, message: "" },
        cpfCreate: { hasError: !id, message: "" },
      }));
    } else {
      clearShipperLinkNotice();
      setDriverIDbyCpf("");
      setErroForm((prev) => ({
        ...prev,
        cpf: { hasError: false, message: "" },
        cpfCreate: { hasError: false, message: "" },
      }));
    }

    // Se veículo for próprio, sincroniza nome e CPF automaticamente
    if (veiculoProprio === true) {
      setProprietario((prev) => ({
          ...prev,
          nome: fullName,
        }));
      setProprietario(prev => ({
        ...prev,
        cpfCnpj: formatMask(cpf) || ""
      }));
      setProprietario(prev => ({
        ...prev,
        tipo: "cpf"
      }));
      setErroNomeCpfIgual(false);
      return;
    }

    if (proprietario.nome && proprietario.cpfCnpj) {
      const isSameAsUser =
        proprietario.nome === fullName &&
        withoutMaskCPF(proprietario.cpfCnpj) === withoutMaskCPF(cpf);
      setErroNomeCpfIgual(isSameAsUser);
    } else {
      setErroNomeCpfIgual(false);
    }
  }, [fullName, cpf, proprietario.nome, proprietario.cpfCnpj, veiculoProprio, verifyCpf, id]);

  // Controla a exibição da pergunta sobre veículo próprio
  useEffect(() => {
    setDisabledList(listDisabled.includes(vehicleType));
  }, [vehicleType, listDisabled]);

  // Define a máscara automatica correta para CPF/CNPJ
  useEffect(() => {
    if (erroNomeCpfIgual) {
      setShowPerguntaVeiculoProprio(true);
    }
  }, [erroNomeCpfIgual]);

  // Validação dos campos de CPF/CNPJ, para sicronização das informações
  useEffect(() => {
    const digits = proprietario.cpfCnpj?.replace(/\D/g, "");

    // só roda se o usuário parar de digitar por 500ms
    const timeout = setTimeout(() => {
      if (digits?.length === 11) {
        setProprietario((prev) => ({
          ...prev,
          tipo: "cpf",
        }));
      } else if (digits?.length === 14) {
        setProprietario((prev) => ({
          ...prev,
          tipo: "cnpj",
        }));
      } else {
        setProprietario((prev) => ({
          ...prev,
          tipo: "",
        }));
      }
    }, 500);

    // cleanup: cancela timeout se o usuário continuar digitando
    return () => clearTimeout(timeout);
  }, [proprietario.cpfCnpj]);

  // Validação dos campos de CPF/CNPJ dos reboques, para sicronização das informações
  useEffect(() => {
    reboques.forEach((reboque, index) => {
      const digits = (reboque.cpfoucnpjReboque || "").replace(/\D/g, "");

      const timeout = setTimeout(() => {
        let novoTipo = "";
        if (digits.length === 11) {
          novoTipo = "cpf";
          handleChangeReboques(index, "tipoProprietarioReboque", novoTipo);
        } else if (digits.length === 14) {
          novoTipo = "cnpj";
          handleChangeReboques(index, "tipoProprietarioReboque", novoTipo);
        }

        if (!digits) {
          if (novoTipo !== reboque.tipoProprietarioReboque) {
            handleChangeReboques(index, "tipoProprietarioReboque", novoTipo);
          }
        }
      }, 500);

      return () => clearTimeout(timeout);
    });
  }, [reboques.map((r) => r.cpfoucnpjReboque).join(",")]);

  useEffect(() => {
    const fetchDriver = async () => {
      if (
        !erroForm.cpfCreate?.hasError ||
        cpf.length !== 14 ||
        id ||
        !users?.uidShipper
      ) {
        return;
      }

      const drivers = await driverService.getDriverByCPF(cpf);
      if (!drivers?.length) return;

      const driver = drivers[0];
      const foundDriverId = driver.driverId;
      setDriverIDbyCpf(foundDriverId);

      const isLinked = await driverService.isDriverLinkedToUserShipper(
        foundDriverId,
        users.uidShipper
      );

      if (!isLinked) {
        showShipperLinkNotice(foundDriverId);
      } else {
        clearShipperLinkNotice();
      }
    };

    fetchDriver();
  }, [erroForm, cpf, id, users?.uidShipper]);

  useLayoutEffect(() => {
    if (!erroForm.cpfCreate?.hasError || !driverIdbyCPF) return;

    navigate(`/driverList/${driverIdbyCPF}`);
  }, [erroForm, driverIdbyCPF, navigate]);

  useEffect(() => {

    async function fetchShipper() {
      if (defaultUIDS === null) {
        try {
          const snapshot = await shipperService.getShipperbyPrincipal();


          if (!snapshot.empty) {
            setDefaultUIDS(snapshot.id);
            setShipperDefault(snapshot);
          }
        }
        catch (error) {
          console.error("Erro ao buscar shipper pelo CNPJ:", error);
        }
      }
    }

    fetchShipper();
  }, []);

  function createReboque() {
    return {
      placaReboque: "",
      renavamReboque: "",
      ufReboque: "",
      descricaoReboque: "",
      rntrcReboque: "",
      tipoRNTRCReboque: "",
      TipoCarroceriaReboque: "",
      pesoTaraReboque: "",
      capacidadeKGReboque: "",
      capacidadeM3Reboque: "",
      tipoProprietarioReboque: "",
      cpfoucnpjReboque: "",
      nomeProprietarioReboque: "",
      veiculoProprioReboque: false,
      cnhReboque: "",
      anttReboque: "",
    };
  }

  function createContact() {
    return {
      nameKinships1: "",
      degreeKinships1: "",
      contactKinships1: "",
    };
  }

  function createContactProfessional() {
    return {
      contactProfessional: "",
      nameProfessional: "",
    };
  }

  const handleChangeReboques = (index, field, value) => {
    const newReboque = [...reboques];

    if (field === "cpfoucnpjReboque") {
      newReboque[index][field] = formatMask(value);
    } else {
      newReboque[index][field] = value;
    }

    setReboques(newReboque);
  };

  const handleChangeContacts = (index, field, value) => {
    const newContact = [...contacts];

    newContact[index][field] = value;
    setContacts(newContact);
  };

  const handleChangeContactsProfessional = (index, field, value) => {
    const newContactProfessional = [...contactsProfessional];
    newContactProfessional[index][field] = value;
    setContactsProfessional(newContactProfessional);
  };

  const adicionarReboque = () => {
    setReboques([...reboques, createReboque()]);
  };

  const adicionarContact = () => {
    setContacts([...contacts, createContact()]);
  };

  const adicionarContactProfessional = () => {
    setContactsProfessional([
      ...contactsProfessional,
      createContactProfessional(),
    ]);
  };

  const removerReboque = (index) => {
    setReboques(reboques.filter((_, i) => i !== index));
  };

  const removerContact = (index) => {
    setContacts(contacts.filter((_, i) => i !== index));
  };

  const removerContactProfessional = (index) => {
    setContactsProfessional(contactsProfessional.filter((_, i) => i !== index));
  };

  const handleUploadCnhReboque = (index, url) => {
    setReboques((prev) => {
      const novos = [...prev];
      novos[index]["cnhReboque"] = url;
      return novos;
    });
  };
  const handleUploadAnttReboque = (index, url) => {
    setReboques((prev) => {
      const novos = [...prev];
      novos[index].anttReboque = url;
      return novos;
    });
  };

  function showMessage(msg) {
    setMsgTipo("erro");
    setCarregando(0);
    setTitle(" Ops!");
    setMsg(msg);
    setOpenDialog(true);
    return;
  }

  const handlePasswordBlur = () => {
    setPasswordTouched(true);
    if (!password) {
      setPasswordError(
        "Senha não obrigatória! Será enviado um email ao motorista com as informações de primeiro acesso!"
      );
    } else {
      setPasswordError("");
    }
  };

  // Valida CPF (retorna true se válido)
  function validateCpf(cpf) { //TODO o cpf de venancio nao passa : 016.111.046-02 verificar!
    // Mantém só dígitos
    cpf = String(cpf).replace(/\D/g, "");

    // Deve ter 11 dígitos e não pode ser todos iguais
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    // --- 1º dígito verificador ---
    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += Number(cpf[i]) * (10 - i);
    }
    let resto = soma % 11;
    const dig1 = resto < 2 ? 0 : 11 - resto;

    // --- 2º dígito verificador ---
    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += Number(cpf[i]) * (11 - i);
    }
    resto = soma % 11;
    const dig2 = resto < 2 ? 0 : 11 - resto;

    // Confere com os dígitos originais
    return cpf.endsWith(String(dig1) + String(dig2));
  }

  function validInput() {
    var retorno = true;
    if (!cpf) {
      showMessage("O CPF precisa ser preenchido corretamente");
      const input = document.getElementById("cpf");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!id) {
      if (!password) {
        showMessage(
          "Motorista cadastrado com sucesso!\n Será enviado ao motorista um email com as informações de primeiro acesso!"
        );
        setPassword(withoutMaskCPF(cpf));
        setConfirmPassword(withoutMaskCPF(cpf));
      }
      if (password !== confirmPassword) {
        showMessage("Senha diverge da confirmação");
        const input = document.getElementById("confirmPassword");
        if (input) {
          input.focus();
          input.style.borderColor = "red";
        }
        retorno = false;
      }
    }

    if (!fullName) {
      showMessage("O Nome do motorista precisa ser preenchido corretamente");
      const input = document.getElementById("fullName");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!birthDate) {
      showMessage("A Data de Nascimento precisa ser preenchido corretamente");
      const input = document.getElementById("birthDateDriver");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!contact) {
      showMessage("O Contato precisa ser preenchido corretamente");
      const input = document.getElementById("contact");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!sexGender) {
      showMessage("O Gênero precisa ser preenchido corretamente");
      const input = document.getElementById("formOfPayment");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!email) {
      showMessage("O email precisa ser preenchido corretamente");
      const input = document.getElementById("email");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!documentCnhExpiration) {
      showMessage(
        "A data de expiração do CNH precisa ser preenchido corretamente"
      );
      const input = document.getElementById("documentCnhExpiration");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (!documentCnh) {
      showMessage("O campo 'CNH' precisa ser preenchido corretamente");
      const input = document.getElementById("documentCnh");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (proprietario.cpfCnpj.length !== 14 && proprietario.cpfCnpj.length !== 18) {
      showMessage("O CPF ou CNPJ do proprietário precisa ser preenchido corretamente");
      const input = document.getElementById("cpfoucnpj");
      if (input) {
        input.focus();
        input.style.borderColor = "red";
      }
      retorno = false;
    }
    if (disabledList) {
      for (let i = 0; i < reboques.length; i++) {
        const reboque = reboques[i];

        var cnpjcpf = Utils.apenasNumerico(reboque.cpfoucnpjReboque);

        if (cnpjcpf.length !== 11 && cnpjcpf.length !== 14) {
          showMessage(
            `O CPF ou CNPJ do reboque ${i + 1
            } precisa ser preenchido corretamente`
          );
          const input = document.getElementById(
            `CPF_CNPJProprietarioReboque${i}`
          );
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.tipoProprietarioReboque) {
          showMessage(
            `O tipo do proprietário do reboque ${i + 1} precisa ser selecionado`
          );
          const input = document.getElementById(`TipoProprietarioReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.nomeProprietarioReboque) {
          showMessage(
            `O nome do proprietário do reboque ${i + 1} precisa ser preenchido`
          );
          const input = document.getElementById(`NomeProprietarioReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.placaReboque) {
          showMessage(`A placa do reboque ${i + 1} precisa ser preenchida`);
          const input = document.getElementById(`PlacaReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.renavamReboque) {
          showMessage(`O RENAVAM do reboque ${i + 1} precisa ser preenchido`);
          const input = document.getElementById(`RenavamReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.ufReboque) {
          showMessage(`A UF do reboque ${i + 1} precisa ser selecionada`);
          const input = document.getElementById(`UFReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.descricaoReboque) {
          showMessage(`A descrição do reboque ${i + 1} precisa ser preenchida`);
          const input = document.getElementById(`DescricaoReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (!reboque.rntrcReboque) {
          showMessage(`O RNTRC do reboque ${i + 1} precisa ser preenchido`);
          const input = document.getElementById(`RNTRCReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (
          !reboque.tipoRNTRCReboque ||
          reboque.tipoRNTRCReboque === "Selecione"
        ) {
          showMessage(
            `O tipo de RNTRC do reboque ${i + 1} precisa ser selecionado`
          );
          const input = document.getElementById(`TipoRNTRCReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }

        if (
          !reboque.TipoCarroceriaReboque ||
          reboque.TipoCarroceriaReboque === "Selecione"
        ) {
          showMessage(
            `O tipo de carroceria do reboque ${i + 1} precisa ser selecionado`
          );
          const input = document.getElementById(`TipoCarroceriaReboque${i}`);
          if (input) {
            input.focus();
            input.style.borderColor = "red";
          }
          retorno = false;
          break;
        }
      }
    }
    if (!documentAnttFrontImg) {
      showMessage("O campo 'Doc ANTT' precisa ter uma imagem importada");
      document.getElementById("documentAnttFrontImg").focus();
      retorno = false;
    }
    if (!documentCnhFrontImg) {
      showMessage("O campo 'CNH' precisa ter uma imagem importada");
      document.getElementById("documentCnhFrontImg").focus();
      retorno = false;
    }
    if (!documentCRLV) {
      showMessage("O campo 'CRLV' precisa ser cadastrado!");
      document.getElementById("documentCRLV").focus();
      retorno = false;
    }
    return retorno;
  }

  function save() {

    console.log("Salvando...");
    if (validInput()) {
      var history = {
        created: new Date(),
        userCreated: users.name,
      };

      var address = {
        cep: withoutMaskCEP(cep),
        city: city ? city : "",
        district: district ? district : "",
        number: number ? number : "",
        state: state ? state : "",
        street: street ? street : "",
        comprovanteEndereco: comprovanteEndereco ? comprovanteEndereco : "",
        complementoEndereco: complementoEndereco ? complementoEndereco : "",
      };

      var dataBank = {
        accountDigit: accountDigit ? accountDigit : "",
        accountNumber: accountNumber ? accountNumber : "",
        agency: agency ? agency : "",
        bankName: bankName ? bankName : "",
        code: code ? code : "",
        holderAccount: holderAccount ? holderAccount : "",
        pix: pix ? pix : "",
      };

      var kinships = [
        {
          contact: withoutMaskPhone(contactKinships1),
          degree: degreeKinships1 ? degreeKinships1 : "",
          name: nameKinships1 ? nameKinships1 : "",
        },
        {
          contact: withoutMaskPhone(contactKinships2),
          degree: degreeKinships2 ? degreeKinships2 : "",
          name: nameKinships2 ? nameKinships2 : "",
        },
        {
          contacts: contacts,
        },
      ];


      var personalData = {
        contact: contact ? contact : "",
        documentAnttFrontImg: documentAnttFrontImg ? documentAnttFrontImg : "",
        documentCRLV: documentCRLV ? documentCRLV : "",
        documentCnhFrontImg: documentCnhFrontImg ? documentCnhFrontImg : "",
        cnhReboque: cnhReboque ? cnhReboque : "",
        fullName: fullName ? fullName : "",
        sexGender: sexGender ? sexGender : "",
        documentCpf: cpf,
        documentCnh: documentCnh ? documentCnh : "",
        anttReboque: anttReboque ? anttReboque : "",
      };

      var professionalData = [
        {
          contact: withoutMaskPhone(contactProfessional),
          name: nameProfessional ? nameProfessional : "",
        },
        {
          contact: withoutMaskPhone(contactProfessional1),
          name: nameProfessional1 ? nameProfessional1 : "",
        },
        {
          contactsProfessional: contactsProfessional,
        },
      ];

      var vehicle = {
        bodyworkPlate: bodyworkPlate ? bodyworkPlate : "",
        bodyworkType: bodyworkType ? bodyworkType : "",
        vehicleImg: vehicleImg ? vehicleImg : "",
        vehiclePlate: vehiclePlate ? vehiclePlate : "",
        vehicleType: vehicleType ? vehicleType : "",
        renavam: renavam ? renavam : "",
        ufVeiculo: ufVeiculo ? ufVeiculo : "",
        descricaoVeiculo: descricaoVeiculo ? descricaoVeiculo : "",
        rntrc: rntrc ? rntrc : "",
        tipoRNTRC: tipoRNTRC ? tipoRNTRC : "",
        pesoTara: pesoTara ? pesoTara : "",
        capacidadeKG: capacidadeKG ? capacidadeKG : "",
        capacidadeM3: capacidadeM3 ? capacidadeM3 : "",
        tipoProprietario: proprietario.tipo ? proprietario.tipo : "",
        cpfoucnpj: proprietario.cpfCnpj ? proprietario.cpfCnpj : "",
        nomeProprietario: proprietario.nome ? proprietario.nome : "",
        veiculoProprio: veiculoProprio ? veiculoProprio : false,
        reboques: reboques,
      };

      const uid = [
        users.uidShipper,
        ...(
          [defaultUIDS].includes(users.uidShipper)
            ? []
            : [defaultUIDS]
        )
      ];


      let shipper = {
        uid: users.uidShipper,
        name: shippers?.dataPersonal?.socialName ? shippers?.dataPersonal?.socialName : "Nome não encontrado",
      };

      if (birthDate && birthDate !== "") {
        let dataComSplit = birthDate.split("-");
        var dataNova = new Date(
          `${dataComSplit[0]}/${dataComSplit[1]}/${dataComSplit[2]}`
        );
      }

      if (dateRenovation && dateRenovation !== "") {
        let dataRenovSplit = dateRenovation.split("-");
        var dataRenovNova = new Date(
          `${dataRenovSplit[1]}/${dataRenovSplit[2]}/${dataRenovSplit[0]}`
        );
      }

      let userPassword = password;

      if (!email) {
        alert("Email obrigatório");
        return;
      } else if (!userPassword) {
        if (cpf) {
          userPassword = withoutMaskCPF(cpf);
        } else {
          alert("CPF obrigatório");
          return;
        }
      }

      firebase
        .auth()
        .createUserWithEmailAndPassword(email, userPassword)
        .then(async (resultado) => {
          let uid = resultado.user.uid;

          var data = {
            birthDate: birthDate ? new Date(dataNova.toString()) : "",
            documentCnhExpiration: documentCnhExpiration
              ? new Date(documentCnhExpiration)
              : "",
            lastUpdatedBackOffice: new Date(),
            dateRenovation: dateRenovation
              ? new Date(dataRenovNova.toString())
              : "",
            address: address,
            dataBank: dataBank,
            kinships: kinships,
            personalData: personalData,
            professionalReference: professionalData,
            vehicle: vehicle,
            shipper: shipper
          };

          var fistData = {
            cpf: withoutMaskCPF(cpf),
            email: email,
            name: fullName,
            uid: uid,
            statusDriver: status,
            accountCreated: new Date(),
            history: history,
            idNotification: "",
            uidShipper: defaultUIDS,
            groups: selectedGroups || []
          };

          await db.collection("drivers_users").doc(uid).set(fistData);

          await db
            .collection("drivers_users")
            .doc(uid)
            .collection("documents")
            .doc("allData")
            .set(data)
            .then(() => {
              setCarregando(0);
              setMsgTipo("sucesso");
              navigate("/driverList");
            });

          await paymentService.prepareEmailDriver(password, email);
        })
        .catch((error) => {
          // setCarregando(0)
          setMsgTipo("erro");
          switch (error.code) {
            case "auth/weak-password":
              setMsg("A senha deve ter pelo menos 6 caracteres.");
              setMsgTipo("erro");
              setTitle("Oops!");
              setOpenDialog(true);
              break;

            case "auth/email-already-in-use":
              setMsg("Este e-mail já está sendo utilizado por outro usuário.");
              setMsgTipo("erro");
              setTitle("Oops!");
              setOpenDialog(true);
              break;

            case "auth/invalid-email":
              setMsg("O formato do seu e-mail é inválido!");
              setMsgTipo("erro");
              setTitle("Oops!");
              setOpenDialog(true);
              break;

            case "auth/user-exists":
            case "auth/user-already-exists":
              setMsg("Usuário já cadastrado no sistema!");
              setMsgTipo("erro");
              setTitle("Oops!");
              setOpenDialog(true);
              break;

            case "auth/missing-password":
              setMsg("A senha é obrigatória para criar o usuário!");
              setMsgTipo("erro");
              setTitle("Oops!");
              setOpenDialog(true);
              break;

            default:
              setMsg(
                "Não foi possível cadastrar. Tente novamente mais tarde ou contate o administrador." + error.code +
                " " + error.message
              );
              setMsgTipo("erro");
              setTitle("Oops!");
              setOpenDialog(true);
              console.error(error);
              break;
          }
        });
    }
  }



  function update() {
    setCarregando(1);

    if (!validInput()) {
      return;
    }

    var history = {
      lastUpdateAutorized: new Date(),
      // (status === "" ? new Date() : "")
    };
    
    var data = {
      email: email ? email : "",
      cpf: withoutMaskCPF(cpf),
      statusDriver: status ? status : "",
      history: history,
      groups: selectedGroups || [],
      name: fullName ? fullName : "",
    };

    var address = {
      cep: withoutMaskCEP(cep),
      city: city ? city : "",
      district: district ? district : "",
      number: number ? number : "",
      state: state ? state : "",
      street: street ? street : "",
      comprovanteEndereco: comprovanteEndereco ? comprovanteEndereco : "",
      complementoEndereco: complementoEndereco ? complementoEndereco : "",
    };

    var dataBank = {
      accountDigit: accountDigit ? accountDigit : "",
      accountNumber: accountNumber ? accountNumber : "",
      agency: agency ? agency : "",
      bankName: bankName ? bankName : "",
      code: code ? code : "",
      holderAccount: holderAccount ? holderAccount : "",
      ispb: ispb ? ispb : "",
      pix: pix ? pix : "",
    };

    var kinships = [
      {
        contact: withoutMaskPhone(contactKinships1),
        degree: degreeKinships1 ? degreeKinships1 : "",
        name: nameKinships1 ? nameKinships1 : "",
      },
      {
        contact: withoutMaskPhone(contactKinships2),
        degree: degreeKinships2 ? degreeKinships2 : "",
        name: nameKinships2 ? nameKinships2 : "",
      },
    ];

    var personalData = {
      contact: contact ? contact : "",
      documentAnttFrontImg: documentAnttFrontImg ? documentAnttFrontImg : "",
      documentCRLV: documentCRLV ? documentCRLV : "",
      documentCnhFrontImg: documentCnhFrontImg ? documentCnhFrontImg : "",
      cnhReboque: cnhReboque ? cnhReboque : "",
      fullName: fullName ? fullName : "",
      sexGender: sexGender ? sexGender : "",
      documentCnh: documentCnh ? documentCnh : "",
      documentCpf: cpf ? cpf : "",
      anttReboque: anttReboque ? anttReboque : "",
    };

    var professionalData = [
      {
        contact: withoutMaskPhone(contactProfessional),
        name: nameProfessional ? nameProfessional : "",
      },
      {
        contact: withoutMaskPhone(contactProfessional1),
        name: nameProfessional1 ? nameProfessional1 : "",
      },
    ];

    var vehicle = {
      bodyworkPlate: bodyworkPlate ? bodyworkPlate : "",
      bodyworkType: bodyworkType ? bodyworkType : "",
      vehicleImg: vehicleImg ? vehicleImg : "",
      vehiclePlate: vehiclePlate ? vehiclePlate : "",
      vehicleType: vehicleType ? vehicleType : "",
      renavam: renavam ? renavam : "",
      ufVeiculo: ufVeiculo ? ufVeiculo : "",
      descricaoVeiculo: descricaoVeiculo ? descricaoVeiculo : "",
      rntrc: rntrc ? rntrc : "",
      tipoRNTRC: tipoRNTRC ? tipoRNTRC : "",
      pesoTara: pesoTara ? pesoTara : "",
      capacidadeKG: capacidadeKG ? capacidadeKG : "",
      capacidadeM3: capacidadeM3 ? capacidadeM3 : "",
      tipoProprietario: proprietario.tipo ? proprietario.tipo : "",
      cpfoucnpj: proprietario.cpfCnpj ? proprietario.cpfCnpj : "",
      nomeProprietario: proprietario.nome ? proprietario.nome : "",
      veiculoProprio: veiculoProprio ? veiculoProprio : false,
      reboques: reboques,
    };

    if (birthDate && birthDate !== "") {
      let dataComSplit = birthDate.split("-");
      var dataNova = new Date(
        `${dataComSplit[0]}/${dataComSplit[1]}/${dataComSplit[2]}`
      );
    }

    if (dateRenovation && dateRenovation !== "") {
      let dataRenovSplit = dateRenovation.split("-");
      var dataRenovNova = new Date(
        `${dataRenovSplit[1]}/${dataRenovSplit[2]}/${dataRenovSplit[0]}`
      );
    }

    const uid = [
      users.uidShipper,
      ...(Array.isArray(persistedShipper?.uid)
        ? persistedShipper?.uid
        : [persistedShipper?.uid]),
      ...(Array.isArray(defaultUIDS) ? defaultUIDS : [defaultUIDS]),
    ].filter(Boolean);

    const uniqueUid = [...new Set(uid)];

    let shipper = {
      name: persistedShipper?.name ? persistedShipper?.name : "",
      uid: uniqueUid,
    };

    var dataAll = {
      birthDate: birthDate ? new Date(dataNova.toString()) : "",
      documentCnhExpiration: documentCnhExpiration
        ? new Date(documentCnhExpiration)
        : "",
      lastUpdatedBackOffice: new Date(),
      dateRenovation: dateRenovation ? new Date(dataRenovNova.toString()) : "",
      address: address,
      dataBank: dataBank,
      kinships: kinships,
      personalData: personalData,
      professionalReference: professionalData,
      vehicle: vehicle,
      shipper: shipper,
    };

    // Se a senha for
    if (password && currentPassword) {
      // 1. Pegue o usuário atual
      var user = firebase.auth().currentUser;

      // 2. Crie as credenciais novamente (com email e senha do usuário)
      const credential = EmailAuthProvider.credential(email, currentPassword);

      // 3. Reautentique
      reauthenticateWithCredential(user, credential)
        .then(() => {
          return updatePassword(user, password);
        })
        .then(() => {
          console.log("Senha atualizada com sucesso");
        })
        .catch((error) => {
          switch (error.message) {
            case "Firebase: This operation is sensitive and requires recent authentication. Log in again before retrying this request. (auth/requires-recent-login).":
              setMsg(
                "Essa operação é muito sensiva e requer uma autenticação recente, por favor realizar o login novamente antes de alterar."
              );
              setMsgTipo("erro");
              setTitle(" Oops!");
              setOpenDialog(true);
              break;
            default:
              setMsg(
                "Não foi possível atualizar a senha. Tente novamente mais tarde ou contate o administrador!"
              );
              setMsgTipo("erro");
              setTitle(" Oops!");
              setOpenDialog(true);
              break;
          }

          console.error("Erro ao atualizar senha:", error);
        });
    }

    db.collection("drivers_users")
      .doc(id)
      .update(data)
      .then(() => {
        db.collection("drivers_users")
          .doc(id)
          .collection("documents")
          .doc("allData")
          .update(dataAll)
          .then(() => {
            setCarregando(0);
            navigate("/driverList");
          });
      })
      .catch((error) => {
        setCarregando(0);
      });
  }

  function buscarCep(input) {
    if (input != null && input.length < 8) {
      return;
    } else {
      fetch("https://viacep.com.br/ws/" + input + "/json/", { mode: "cors" })
        .then((res) => res.json())
        .then((data) => {
          if (data.hasOwnProperty("erro")) {
            alert("Cep não existente");
          } else {
            setStreet(data?.logradouro);
            setDistrict(data?.bairro);
            setCity(data?.localidade);
            setState(data?.uf);
          }
        })
        .catch((err) => console.error(err));
    }
  }

  function withoutMaskPhone(input) {
    return input
      ? input
        .replace("(", "")
        .replace(")", "")
        .replace(" ", "")
        .replace("-", "")
      : "";
  }

  function withoutMaskCPF(input) {
    return input
      ? input.replace(".", "").replace(".", "").replace("-", "")
      : "";
  }

  function withoutMaskCEP(input) {
    return input ? input.replace("-", "") : "";
  }

  const handleReset = async () => {
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage(
        "E-mail de redefinição enviado. Contate o(a) motorista para verificar sua caixa de e-mail."
      );
      setError("");
      setShowResetPassword(true);
    } catch (err) {
      setError("Erro ao enviar e-mail. Verifique o endereço de e-mail.");
      setMessage("");
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleUpload = (file) => {
    if (!file) return;

    var contest = file;

    const storageRef = ref(storage, `drivers_users/${id}/${contest.name}`);

    const uploadTask = uploadBytesResumable(storageRef, contest);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
      },
      (error) => {
        alert(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          if (origem === "ANTT Frente") {
            setDocumentAnttFrontImg(downloadURL);
            setOpen(false);
            setOrigem("");
            contest = null;
          } else if (origem === "ANTT Verso") {
            setdocumentCRLV(downloadURL);
            setOpen(false);
            setOrigem("");
          } else if (origem === "CNH Frente") {
            setDocumentCnhFrontImg(downloadURL);
            setOpen(false);
            setOrigem("");
          } else if (origem.startsWith("CNH Verso")) {
            const index = parseInt(origem.replace("CNH Verso ", ""));
            handleUploadCnhReboque(index, downloadURL);
            setOpen(false);
            setOrigem("");
            return;
          } else if (origem === "Imagem veiculo") {
            setVehicleImg(downloadURL);
            setOpen(false);
            setOrigem("");
          } else if (origem.startsWith("Antt Reboque")) {
            const index = parseInt(origem.replace("Antt Reboque ", ""));
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              handleUploadAnttReboque(index, downloadURL);
              setOpen(false);
              setOrigem("");
            });
            return;
          } else if (origem === "Comprovante Endereco") {
            setComprovanteEndereco(downloadURL);
            setOpen(false);
            setOrigem("");
          }
        });
      }
    );
  };

  const handleDelete = async (downloadUrl) => {
    try {
      // Extrair o caminho do arquivo a partir da URL
      const pathStart = downloadUrl.indexOf("/o/") + 3;
      const pathEnd = downloadUrl.indexOf("?", pathStart);
      const encodedPath = downloadUrl.substring(pathStart, pathEnd);
      const filePath = decodeURIComponent(encodedPath);

      // Referência ao arquivo no Firebase Storage
      const fileRef = ref(storage, filePath);

      // Deletar o arquivo
      await deleteObject(fileRef);

      console.log("Arquivo excluído com sucesso!");
    } catch (error) {
      console.error("Erro ao excluir o arquivo:", error);
      alert("Erro ao excluir o arquivo.");
    }
  };

  const onChangeStatus = (e) => {
    setStatus(e.target.value);
  };

  const formatMask = (value) => {
    if (!value) return value;

    const raw = value.replace(/\D/g, "");
    if (raw.length === 11) {
      return raw.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (raw.length === 14) {
      return raw.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    }
    return value;
  };

  const handleCheckboxChange = (e) => {
    setVeiculoProprio(e.target.checked);
  };

  const formatarPeso = (valor) => {
    let valorFormatado = "0";
    if (valor !== undefined && valor !== null && valor !== "") {
      const numeros = valor.replace(/\D/g, "");
      valorFormatado = parseInt(numeros || "0", 10).toLocaleString("pt-BR");
      return valorFormatado;
    }
    return valorFormatado;
  };

  const handlePesoChange = (index, campo, valor) => {
    let valorFormatado = "0,00";
    if (valor !== undefined && valor !== null && valor !== "") {
      valorFormatado = formatarPeso(valor);
    }
    handleChangeReboques(index, campo, valorFormatado);
  };

  const handleChangeTypeVeiculo = (value) => {
    if (
      value == "CARRETA S" ||
      value == "CARRETA LS" ||
      value == "BITREM" ||
      value == "RODOTREM" ||
      value == "VANDERLEIA"
    ) {
      setPesoTara("0");
      setCapacidadeKG("0");
      setCapacidadeM3("0");
      setDisabledList(true);
    }

    setVehicleType(value);
  };

  const apenasLetras = (valor) => valor.replace(/[^A-Za-zÀ-ÿ\s]/g, "");
  const apenasNumeros = (valor) => valor.replace(/\D/g, "");

  const formatarAgencia = (valor) => {
    return valor
      .replace(/\D/g, "")
      .replace(/^(\d{4})(\d)/, "$1-$2")
      .slice(0, 6); // 5 números + hífen
  };

  const formatCpfOuCnpj = (valor, tipo) => {
    if (!valor) return "";
    const nums = String(valor).replace(/\D/g, "");
    if (tipo === "cpf") {
      const v = nums.slice(0, 11);
      return v
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    }
    if (tipo === "cnpj") {
      const v = nums.slice(0, 14);
      return v
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
    }

    return valor;
  };

  const aplicarMascaraCpfCnpj = (valor, tipo) => {
    if (!valor) return "";

    // Remove tudo que não for número
    let v = valor.replace(/\D/g, "");

    if (tipo === "cpf") {
      // CPF: 123.456.789-01 (11 dígitos)
      v = v.slice(0, 11);
      if (v.length <= 3) return v;
      if (v.length <= 6) return v.slice(0, 3) + "." + v.slice(3);
      if (v.length <= 9) return v.slice(0, 3) + "." + v.slice(3, 6) + "." + v.slice(6);
      return v.slice(0, 3) + "." + v.slice(3, 6) + "." + v.slice(6, 9) + "-" + v.slice(9);
    }

    if (tipo === "cnpj") {
      // CNPJ: 12.345.678/0001-90 (14 dígitos)
      v = v.slice(0, 14);
      if (v.length <= 2) return v;
      if (v.length <= 5) return v.slice(0, 2) + "." + v.slice(2);
      if (v.length <= 8) return v.slice(0, 2) + "." + v.slice(2, 5) + "." + v.slice(5);
      if (v.length <= 12) return v.slice(0, 2) + "." + v.slice(2, 5) + "." + v.slice(5, 8) + "/" + v.slice(8);
      return v.slice(0, 2) + "." + v.slice(2, 5) + "." + v.slice(5, 8) + "/" + v.slice(8, 12) + "-" + v.slice(12);
    }

    return v;
  };

  const handleBlurProprietario = () => {
    if (proprietario.cpfCnpj && proprietario.tipo) {
      const formatted = aplicarMascaraCpfCnpj(
        proprietario.cpfCnpj,
        proprietario.tipo
      );
      if (formatted !== proprietario.cpfCnpj) {
        setProprietario({
          ...proprietario,
          cpfCnpj: formatted,
        });
      }
    }
  };

  const handleSave = () => {
    const camposInvalidos = getInvalidFields();

    if (camposInvalidos.length > 0) {
      // Exibe alerta com todos os campos faltando de uma vez
      setTitle("Campos( obrigatórios faltando");
      showMessage(
        "O(s) seguinte(s) campo(s) obrigatório(s) estão vazio(s):\n\n- " +
        camposInvalidos.join("\n- ")
      );
      //setStatus("error");
      // setOpen(true);
      //setLoading(false);
      return; // Para a execução e não salva
    }
    id ? update() : save();
  };

  const getInvalidFields = () => {
    const erros = [];

    if (!ufVeiculo) {
      erros.push("CAMPO UF VEÍCULO OBRIGATÓRIO");
    }

    return erros;
  };

  return (
    <>
      {useSelector((state) => state.usuarioLogado) > 0 ? (
        <NewMiniDrawer
          divOpen={
            <>
            <Layout style={{ minHeight: "100vh", marginTop: "-20px" }}>
              <AlertDialog
                handleClose={handleClose}
                open={open}
                origem={origem}
                handleUpload={handleUpload}
              />

              <Content style={{ padding: "20px", marginTop: "0px" }}>
                <Spin spinning={carregando === 1}>
                  <Row gutter={10} style={{ marginBottom: "20px" }}>
                  {/* Left Side - Statistics */}
                  <Col span={10} style={{}}>
                    <Card
                      border={true}
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        padding: "24px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                        background: "#fff",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",

                          marginBottom: "20px",
                        }}
                      >
                        <Avatar
                          size={120}
                          src="https://via.placeholder.com/150"
                          style={{
                            marginRight: "10px",
                            border: "2px solid #1890ff",
                            flexShrink: 0,
                            position: "sticky",
                          }}
                        />

                        <div>
                          <Title
                            level={4}
                            style={{
                              margin: "5px",
                              marginTop: "50px",
                              fontWeight: "bold",
                              fontSize: "clamp(10px, 2vw, 15px)",
                            }}
                          >
                            {fullName ? fullName : " Nome do Motorista"}
                          </Title>
                          <Rate
                            allowHalf
                            defaultValue={1.0}
                            value={1.0}
                            style={{}}
                          />
                        </div>
                      </div>
                    </Card>

                    <Row gutter={[24, 24]}>
                      {[
                        {
                          title: "Total de Viagens",
                          value: `0${totalDocuments}`,
                          color: "#1890ff",
                          bg: "#e6f7ff",
                        },
                        {
                          title: "Total Recebido",
                          value: "R$ 0,00",
                          color: "#52c41a",
                          bg: "#f6ffed",
                        },
                        {
                          title: "Entregas Efetuadas",
                          value: totalFinalized,
                          color: "#1890ff",
                          bg: "#e6f7ff",
                        },
                        {
                          title: "Ocorrências",
                          value: "0",
                          color: "#ff4d4f",
                          bg: "#fff1f0",
                        },
                      ].map((item, index) => (
                        <Col span={12} key={index}>
                          <Card
                            bordered={false}
                            hoverable
                            style={{
                              background: item.bg,
                              borderRadius: "12px",
                              textAlign: "center",
                              padding: "16px",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                              border: "1px solid gray",
                            }}
                            bodyStyle={{
                              padding: "16px",
                              transform: "translateY(0)",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform =
                                "translateY(-5px) scale(1.02)";
                              e.currentTarget.style.boxShadow =
                                "0 6px 16px rgba(0,0,0,0.15)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform =
                                "translateY(0) scale(1)";
                              e.currentTarget.style.boxShadow = "none";
                            }}
                          >
                            <Title
                              level={5}
                              style={{ marginBottom: "4px", color: item.color }}
                            >
                              {item.title}
                            </Title>
                            <Title
                              level={3}
                              style={{ margin: 0, color: item.color }}
                            >
                              {item.value}
                            </Title>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Col>

                  {/* Right Side - Statistics */}
                  <Col span={14} style={{ paddingTop: "10px" }}>
                    <Card
                      size="small"
                      style={{
                        fontSize: "16px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "10px",
                        width: "100%",
                      }}
                      bodyStyle={{
                        padding: "8px 12px", 
                      }}
                    >
                      <div
                        style={{
                          marginBottom: "20px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",

                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            whiteSpace: "nowrap",
                            marginRight: "10px",
                          }}
                        >
                          Cadastro de Motorista
                        </span>
                        <Radio.Group
                          disabled={view}
                          onChange={onChangeStatus}
                          value={status && status}
                          style={{ flexShrink: "100", display: "flex", gap: "0px,", alignItems: "center", marginLeft: "auto" }}
                        >
                          <Radio value={"authorized"} style={{ marginRight: "2px", marginLeft: "0" }}>Autorizado</Radio>
                          <Radio value={"informed"} style={{ marginRight: "2px", marginLeft: "0" }}>Pendente</Radio>
                          <Radio value={"incomplete"} style={{ marginRight: "2px", marginLeft: "0" }}>Incompleto</Radio>
                          <Radio value={"failed"} style={{ marginRight: "2", marginLeft: "0" }}>Rejeitado</Radio>
                        </Radio.Group>
                      </div>
                      <Row gutter={16}>
                        <Col span={14}>
                          <div className="col-md-12 mt-4">
                            <label htmlFor="fullName" className="form-label">
                              Nome Completo{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setFullName(e.target.value)}
                              value={fullName && fullName}
                              className={`form-control ${fullName === "" ? "empty-field" : ""
                                }`}
                              id="fullName"
                            />
                          </div>
                        </Col>
                        <Col span={10}>
                          <label htmlFor="cpf" className="form-label mt-4">
                            CPF <span style={{ color: "red" }}>*</span>
                          </label>
                          <InputMask
                            disabled={view}
                            mask="999.999.999-99"
                            className="form-control"
                            onChange={(e) => setCpf(e.target.value)}
                            value={cpf && cpf}
                            id="cpf"
                            maskChar={null}
                            alwaysShowMask={false}
                          />
                          {erroForm?.cpf?.hasError && (
                            <div className="fade-message">
                              <small className="text-danger">
                                {erroForm.cpf.message}
                              </small>
                            </div>
                          )}
                          {
                            erroForm?.cpfCreate?.hasError && (
                              <div className="fade-message">
                                <small className="text-danger">
                                  {erroForm.cpfCreate.message}
                                </small>
                              </div>
                            )
                          }
                          {showInlineShipperLinkNotice && (
                            <Alert
                              severity="info"
                              sx={{ mt: 1 }}
                              onClose={clearShipperLinkNotice}
                            >
                              {SHIPPER_LINK_NOTICE_MESSAGE}
                            </Alert>
                          )}
                        </Col>
                      </Row>

                      <Row gutter={16} style={{ marginTop: "16px" }}>
                        <Col span={8}>
                          <div className="col-md-12">
                            <label htmlFor="nome" className="form-label">
                              Data nascimento{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="date"
                              onChange={(e) => setBirthDate(e.target.value)}
                              value={birthDate && birthDate}
                              className="form-control"
                              id="birthDateDriver"
                            />
                          </div>
                        </Col>
                        <Col span={8}>
                          <div className="col-md-12">
                            <label htmlFor="nome" className="form-label">
                              Celular <span style={{ color: "red" }}>*</span>
                            </label>
                            <InputMask
                              disabled={view}
                              mask="(99) 99999-9999"
                              className="form-control"
                              onChange={(e) => setContact(e.target.value)}
                              value={contact && contact}
                              id="contact"
                            />
                          </div>
                        </Col>
                        <Col span={8}>
                          <div className="col-md-12">
                            <label htmlFor="sexGender" className="form-label">
                              Gênero <span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              disabled={view}
                              className="form-select"
                              id="formOfPayment"
                              value={sexGender && sexGender}
                              onChange={(e) => setSexGender(e.target.value)}
                              aria-label=""
                            >
                              <option defaultValue="">Selecione</option>
                              <option value="Masculino">Masculino</option>
                              <option value="Feminino">Feminino</option>
                              <option value="Outro">Outro</option>
                              <option value="Prefiro não dizer">
                                Prefiro não dizer
                              </option>
                            </select>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={16} style={{ marginTop: "16px" }}>
                        <Col span={8}>
                          <div className="col-md-12">
                            <label htmlFor="numeroCNH" className="form-label">
                              Número CNH <span style={{ color: "red" }}>*</span>
                            </label>
                            {/* <input type="text" onChange={(e)=> setDocumentCnh(e.target.value)} value={documentCnh && documentCnh} className="form-control" id="numeroCNH"/> */}
                            <input
                              disabled={view}
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              className="form-control"
                              id="numeroCNH"
                              value={documentCnh && documentCnh}
                              onChange={(e) => {
                                const onlyNumbers = e.target.value.replace(
                                  /\D/g,
                                  ""
                                );
                                setDocumentCnh(onlyNumbers);
                              }}
                              maxLength={12} // previne que o usuário digite muito mais do que 11
                              placeholder="Somente números"
                            />
                            {(documentCnh || "").length > 11 && (
                              <div className="fade-message">
                                <small className="text-danger">
                                  A CNH não pode ter mais de 11 dígitos.
                                </small>
                              </div>
                            )}
                          </div>
                        </Col>
                        <Col span={8}>
                          <div className="col-md-12">
                            <label
                              htmlFor="documentCnhExpiration"
                              className="form-label"
                            >
                              Validade CNH{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="date"
                              onChange={(e) =>
                                setDocumentCnhExpiration(e.target.value)
                              }
                              value={
                                documentCnhExpiration && documentCnhExpiration
                              }
                              className="form-control"
                              id="documentCnhExpiration"
                            />
                          </div>
                        </Col>
                        <Col span={8}>
                          <div className="col-md-12">
                            <div>
                              <label
                                tabIndex={"0"}
                                id="documentCnhFrontImg"
                                htmlFor="documentCnhFrontImg"
                                className="form-label"
                              >
                                CNH <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>

                            {documentCnhFrontImg ? (
                              <ul
                                className="col-md-12"
                                style={{
                                  listStyle: "none",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                <li
                                  style={{
                                    background: "#f8f9fa",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: "2px 3px",
                                    marginBottom: "4px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  <a
                                    href={documentCnhFrontImg}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      width: "100%",
                                      textDecoration: "none",
                                      color: "#007bff",
                                      fontWeight: 500,
                                      marginRight: 10,
                                      padding: "6px 14px",
                                      borderRadius: 6,
                                      background:
                                        "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)",
                                      // border: "1px solid #b6d4fe",
                                      boxShadow:
                                        "0 2px 8px rgba(0,123,255,0.08)",
                                      transition:
                                        "background 0.2s, color 0.2s, box-shadow 0.2s",
                                      display: "inline-block",
                                      cursor: "pointer",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.background =
                                        "#d0e7ff";
                                      e.currentTarget.style.color = "#0056b3";
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(0,123,255,0.15)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.background =
                                        "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)";
                                      e.currentTarget.style.color = "#007bff";
                                      e.currentTarget.style.boxShadow =
                                        "0 2px 8px rgba(0,123,255,0.08)";
                                    }}
                                  >
                                    CNH
                                  </a>
                                  <IconButton
                                    disabled={view}
                                    aria-label="Excluir"
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                      handleDelete(documentCnhFrontImg);
                                      setDocumentCnhFrontImg(null);
                                    }}
                                    sx={{
                                      "&:hover": {
                                        backgroundColor:
                                          "rgba(211, 47, 47, 0.1)",
                                        transform: "scale(1.1)",
                                      },
                                      transition: "all 0.2s ease-in-out",
                                      padding: "4px",
                                      borderRadius: "50%",
                                      border: "1px solid transparent",
                                      "&:focus": {
                                        outline: "none",
                                        border: "1px solid #d32f2f",
                                      },
                                    }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </li>
                              </ul>
                            ) : (
                              <Button
                                disabled={view}
                                className="col-md-12"
                                variant="outlined"
                                onClick={() => {
                                  handleClickOpen();
                                  setOrigem("CNH Frente");
                                }}
                              >
                                Importar Documento
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>

                      <Row
                        gutter={16}
                        style={{ marginTop: "16px", paddingBottom: "7px" }}
                      >
                        <Col span={8}>
                          <div className="col-md-12">
                            <label htmlFor="email" className="form-label">
                              E-mail (Login do motorista){" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>

                            <input
                              type="email"
                              disabled={id ? true : view ? view : false}
                              onChange={(e) => setEmail(e.target.value)}
                              value={email || ""}
                              className="form-control"
                              id="email"
                            />
                          </div>
                        </Col>

                        <>
                          {id && (
                            <Col span={8}>
                              <div className="col-md-12">
                                <label htmlFor="email" className="form-label">
                                  Redefinir senha do motorista{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Tooltip title="Será enviado um link para o motorista por e-mail para redefinição de senha">
                                  <Button
                                    disabled={view}
                                    type="primary"
                                    danger
                                    variant="text"
                                    onClick={handleReset}
                                  >
                                    Redefinir Senha
                                  </Button>
                                  {showResetPassword && (
                                    <>
                                      {message && (
                                        <p style={{ color: "green" }}>
                                          {message}
                                        </p>
                                      )}
                                      {error && (
                                        <p style={{ color: "red" }}>{error}</p>
                                      )}
                                    </>
                                  )}
                                </Tooltip>
                              </div>
                            </Col>
                          )}
                        </>

                        {!id && (
                          <>
                            <Col span={8}>
                              <div className="col-md-12">
                                <label
                                  htmlFor="password"
                                  className="form-label"
                                >
                                  Senha{" "}
                                  {/* <span style={{ color: 'red' }}>*</span> */}
                                </label>
                                <PasswordInput
                                  disabled={view}
                                  onBlur={handlePasswordBlur}
                                  onChange={(value) => {
                                    setPassword(value);
                                    if (passwordTouched && value)
                                      setPasswordError("");
                                  }}
                                  id="password"
                                />
                                {passwordError && (
                                  <div
                                    style={{ color: "red", fontSize: "0.9em" }}
                                  >
                                    {passwordError}
                                  </div>
                                )}
                              </div>
                            </Col>
                            <Col span={8}>
                              <div className="col-md-12">
                                <label
                                  htmlFor="passwordConfirm"
                                  className="form-label"
                                >
                                  Confirme senha{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <PasswordInput
                                  disabled={view}
                                  onChange={(value) =>
                                    setConfirmPassword(value)
                                  }
                                  id="confirmPassword"
                                />
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                      <Row gutter={16} style={{marginTop: "16px"}}>
                        <Col span={24}>
                          <div className="col-md-12 mt-4">
                            <label htmlFor="groups" className="form-label" >
                              Grupos{" "}
                            </label>
                            <Autocomplete
                              multiple
                              disabled={view}
                              id="groups-autocomplete"
                              size="small"
                              value={selectedGroupsObjects}
                              getOptionLabel={(option) => option.name || ""}
                              options={groups}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onChange={(event, newValue) => {
                                setSelectedGroupsObjects(newValue);
                                setSelectedGroups(newValue.map((group) => group.id));
                              }}
                              clearOnBlur
                              noOptionsText="Nenhum grupo encontrado"
                              sx={{ width: "35%"}}
                              renderInput={(params) => <TextField {...params} label="" placeholder="Selecione os grupos" />}
                              renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                  {option.name}
                                  {option.description && ` - ${option.description}`}
                                </li>
                              )}
                              filterOptions={(options, { inputValue }) => {
                                const normalizedInput = inputValue.trim().toLowerCase();
                                return options.filter((option) => {
                                  const nameMatch = option.name
                                    ?.toLowerCase()
                                    .includes(normalizedInput);
                                  const descMatch = option.description
                                    ?.toLowerCase()
                                    .includes(normalizedInput);
                                  return nameMatch || descMatch;
                                });
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                </Row>

                {/* Tabs */}
                <Card style={{ marginTop: "20px" }}>
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Veículos Tração" key="2">
                      <div className="row">
                        <div className="col-2">
                          <label htmlFor="vehiclePlate" className="form-label">
                            Placa do veículo
                          </label>
                          <InputMask
                            disabled={view}
                            mask="aaa-9*99"
                            maskChar=""
                            value={vehiclePlate}
                            onChange={(e) =>
                              setVehiclePlate(e.target.value.toUpperCase())
                            }
                          >
                            {(inputProps) => (
                              <input
                                disabled={view}
                                {...inputProps}
                                className="form-control"
                                id="vehiclePlate"
                                placeholder="ABC-1234"
                              />
                            )}
                          </InputMask>
                        </div>
                        <div className="col-2">
                          <label htmlFor="renavam" className="form-label">
                            Renavam
                          </label>
                          <input
                            disabled={view}
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            className="form-control"
                            id="renavam"
                            value={renavam && renavam}
                            onChange={(e) => {
                              const onlyNumbers = e.target.value.replace(
                                /\D/g,
                                ""
                              );
                              setRenavam(onlyNumbers);
                            }}
                            maxLength={11} // previne que o usuário digite muito mais do que 11
                            placeholder="Somente números"
                          />
                          {(renavam || "").length > 11 && (
                            <div className="fade-message">
                              <small className="text-danger">
                                O RENAVAM não pode ter mais de 11 dígitos.
                              </small>
                            </div>
                          )}
                        </div>
                        <div style={{ width: "20%" }}>
                          <label htmlFor="ufVeiculo" className="form-label">
                            UF Veículo <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            id="ufVeiculo"
                            value={ufVeiculo || ""}
                            onChange={(e) => setUfVeiculo(e.target.value)}
                          >
                            <option value="">Selecione um estado</option>
                            {statesUF.map((state) => (
                              <option key={state.value} value={state.value}>
                                {state.label} ({state.value})
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-2">
                          <div>
                            <label
                              tabIndex={"0"}
                              id="documentCRLV"
                              htmlFor="documentCRLV"
                              className="form-label"
                            >
                              CRLV <span style={{ color: "red" }}>*</span>{" "}
                            </label>
                          </div>
                          {documentCRLV ? (
                            <ul
                              style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              <li
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  padding: "2px 3px",
                                  marginBottom: "4px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                <a
                                  href={documentCRLV}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    width: "100%",
                                    textDecoration: "none",
                                    color: "#007bff",
                                    fontWeight: 500,
                                    marginRight: 10,
                                    padding: "6px 14px",
                                    borderRadius: 6,
                                    background:
                                      "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)",
                                    // border: "1px solid #b6d4fe",
                                    boxShadow: "0 2px 8px rgba(0,123,255,0.08)",
                                    transition:
                                      "background 0.2s, color 0.2s, box-shadow 0.2s",
                                    display: "inline-block",
                                    cursor: "pointer",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.background =
                                      "#d0e7ff";
                                    e.currentTarget.style.color = "#0056b3";
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 12px rgba(0,123,255,0.15)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.background =
                                      "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)";
                                    e.currentTarget.style.color = "#007bff";
                                    e.currentTarget.style.boxShadow =
                                      "0 2px 8px rgba(0,123,255,0.08)";
                                  }}
                                >
                                  CRLV
                                </a>
                                <IconButton
                                  disabled={view}
                                  aria-label="Excluir"
                                  size="small"
                                  color="error"
                                  onClick={() => {
                                    handleDelete(documentCRLV);
                                    setdocumentCRLV(null);
                                  }}
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "rgba(211, 47, 47, 0.1)",
                                      transform: "scale(1.1)",
                                    },
                                    transition: "all 0.2s ease-in-out",
                                    padding: "4px",
                                    borderRadius: "50%",
                                    border: "1px solid transparent",
                                    "&:focus": {
                                      outline: "none",
                                      border: "1px solid #d32f2f",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </li>
                            </ul>
                          ) : (
                            <Button
                              disabled={view}
                              variant="outlined"
                              onClick={(e) => {
                                handleClickOpen();
                                setOrigem("ANTT Verso");
                              }}
                            >
                              Importar Documento
                            </Button>
                          )}
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-4">
                          <label
                            htmlFor="descricaoVeiculo"
                            className="form-label"
                          >
                            Descrição Veículo
                          </label>
                          <input
                            disabled={view}
                            type="text"
                            maxLength={200}
                            onChange={(e) =>
                              setDescricaoVeiculo(e.target.value)
                            }
                            value={descricaoVeiculo || ""}
                            className="form-control"
                            id="descricaoVeiculo"
                          />
                        </div>

                        <small className="text-muted">
                          {descricaoVeiculo?.length || 0}/200 caracteres
                        </small>

                        <div className="col-md-2">
                          <label htmlFor="vehicleType" className="form-label">
                            Tipo de veículo
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            id="formOfPayment"
                            value={vehicleType && vehicleType}
                            onChange={(e) =>
                              handleChangeTypeVeiculo(e.target.value)
                            }
                            aria-label=""
                          >
                            <option defaultValue="">Selecione</option>
                            <option value="FIORINO">FIORINO</option>
                            <option value="TRUCK">TRUCK</option>
                            <option value="BI-TRUCK">BI-TRUCK</option>
                            <option value="CARRETA S">CARRETA S</option>
                            <option value="CARRETA LS">CARRETA LS</option>
                            <option value="TOCO">TOCO</option>
                            <option value="3/4">3/4</option>
                            <option value="VUC">VUC</option>
                            <option value="BITREM">BITREM</option>
                            <option value="RODOTREM">RODOTREM</option>
                            <option value="MUNK">MUNK</option>
                            <option value="VANDERLEIA">VANDERLEIA</option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div className="col-2">
                          <label htmlFor="RNTRC" className="form-label">
                            RNTRC
                          </label>
                          <input
                            disabled={view}
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            className="form-control"
                            id="RNTRC"
                            value={rntrc}
                            onChange={(e) => {
                              let valor = e.target.value.replace(/\D/g, "");
                              setRntrc(valor);
                            }}
                            maxLength={8}
                            placeholder="Apenas números"
                          />
                          {rntrc &&
                            (rntrc[0] === "0"
                              ? rntrc.length - 1
                              : rntrc.length) > 8 && (
                              <div className="fade-message">
                                <small className="text-danger">
                                  O RNTRC deve conter no máximo 8 dígitos
                                  válidos!
                                </small>
                              </div>
                            )}
                        </div>

                        <div class="col-2">
                          <label htmlFor="tipoRNTRC" className="form-label">
                            Tipo RNTRC
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            id="formOfPayment"
                            value={tipoRNTRC && tipoRNTRC}
                            onChange={(e) => setTipoRNTRC(e.target.value)}
                            aria-label=""
                          >
                            <option defaultValue="">Selecione</option>
                            <option value="tac">TAC</option>
                            <option value="etc">ETC</option>
                            <option value="ctc">CTC</option>
                          </select>
                        </div>
                        <div className="col-2">
                          <label htmlFor="bodyworkType" className="form-label">
                            Tipo Carroceria
                          </label>

                          <select
                            className="form-select"
                            id="formOfPayment"
                            value={bodyworkType && bodyworkType}
                            onChange={(e) => setBodyworkType(e.target.value)}
                            aria-label=""
                            disabled={disabledList || view}
                          >
                            <option defaultValue="">Selecione</option>
                            <option value="BOBINEIRA">BOBINEIRA</option>
                            <option value="GRADE BAIXA">GRADE BAIXA</option>
                            <option value="BAÚSECO">BAÚSECO</option>
                            <option value="BAÚ FRIGORIFICO">
                              BAÚ FRIGORIFICO
                            </option>
                            <option value="ABERTO">ABERTO</option>
                            <option value="BAÚ">BAÚ</option>
                            <option value="DOLLY">DOLLY</option>
                            <option value="GRANELEIRO">GRANELEIRO</option>
                            <option value="SIDER">SIDER</option>
                            <option value="PRANCHA">PRANCHA</option>
                            <option value="TANQUE">TANQUE</option>
                            <option value="CAÇAMBA">CAÇAMBA</option>
                            <option value="PORTA CONTEINER">
                              PORTA CONTEINER
                            </option>
                            <option value="CILO">CILO</option>
                            <option value="CEGONHA">CEGONHA</option>
                          </select>
                        </div>
                        <div className="col-2">
                          <div>
                            <label
                              tabIndex={"0"}
                              id="documentAnttFrontImg"
                              htmlFor="documentAnttFrontImg"
                              className="form-label"
                            >
                              {" "}
                              Doc ANTT <span style={{ color: "red" }}>
                                *
                              </span>{" "}
                            </label>
                          </div>
                          {documentAnttFrontImg ? (
                            <ul
                              style={{
                                listStyle: "none",
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              <li
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "6px",
                                  padding: "2px 3px",
                                  marginBottom: "4px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                <a
                                  href={documentAnttFrontImg}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    width: "100%",
                                    textDecoration: "none",
                                    color: "#007bff",
                                    fontWeight: 500,
                                    marginRight: 10,
                                    padding: "6px 14px",
                                    borderRadius: 6,
                                    background:
                                      "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)",
                                    // border: "1px solid #b6d4fe",
                                    boxShadow: "0 2px 8px rgba(0,123,255,0.08)",
                                    transition:
                                      "background 0.2s, color 0.2s, box-shadow 0.2s",
                                    display: "inline-block",
                                    cursor: "pointer",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.background =
                                      "#d0e7ff";
                                    e.currentTarget.style.color = "#0056b3";
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 12px rgba(0,123,255,0.15)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.background =
                                      "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)";
                                    e.currentTarget.style.color = "#007bff";
                                    e.currentTarget.style.boxShadow =
                                      "0 2px 8px rgba(0,123,255,0.08)";
                                  }}
                                >
                                  ANTT Veículo
                                </a>
                                <IconButton
                                  disabled={view}
                                  aria-label="Excluir"
                                  size="small"
                                  color="error"
                                  onClick={() => {
                                    handleDelete(documentAnttFrontImg);
                                    setDocumentAnttFrontImg(null);
                                  }}
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "rgba(211, 47, 47, 0.1)",
                                      transform: "scale(1.1)",
                                    },
                                    transition: "all 0.2s ease-in-out",
                                    padding: "4px",
                                    borderRadius: "50%",
                                    border: "1px solid transparent",
                                    "&:focus": {
                                      outline: "none",
                                      border: "1px solid #d32f2f",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </li>
                            </ul>
                          ) : (
                            <Button
                              disabled={view}
                              variant="outlined"
                              onClick={(e) => {
                                handleClickOpen();
                                setOrigem("ANTT Frente");
                              }}
                            >
                              Importar Documento
                            </Button>
                          )}
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-2">
                          <label htmlFor="pesoTara" className="form-label">
                            Peso (Tara)
                          </label>
                          <input
                            type="text"
                            maxLength={10}
                            onChange={(e) =>
                              setPesoTara(formatarPeso(e.target.value))
                            }
                            value={pesoTara || "0"}
                            className="form-control"
                            id="pesoTara"
                            placeholder="0"
                            disabled={disabledList || view}
                          />
                        </div>
                        <div class="col-2">
                          <label htmlFor="capacidadeKG" className="form-label">
                            Capacidade (KG)
                          </label>
                          <input
                            type="text"
                            maxLength={10}
                            onChange={(e) =>
                              setCapacidadeKG(formatarPeso(e.target.value))
                            }
                            value={capacidadeKG || "0"}
                            className="form-control"
                            id="capacidadeKG"
                            placeholder="0"
                            disabled={disabledList || view}
                          />
                        </div>
                        <div class="col-2">
                          <label htmlFor="capacidadeM3" className="form-label">
                            Capacidade (M³)
                          </label>
                          <input
                            type="text"
                            maxLength={10}
                            onChange={(e) =>
                              setCapacidadeM3(formatarPeso(e.target.value))
                            }
                            value={capacidadeM3 || "0"}
                            className="form-control"
                            id="capacidadeM3"
                            placeholder="0"
                            disabled={disabledList || view}
                          />
                        </div>
                      </div>

                      <div class="row">
                        <div className="col-2">
                          <label
                            htmlFor="tipoProprietario"
                            className="form-label"
                          >
                            Tipo Proprietário
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            id="tipoProprietario"
                            value={proprietario.tipo}
                            onChange={(e) => {
                              setProprietario({
                                ...proprietario,
                                tipo: e.target.value,
                                cpfCnpj: "",
                                erroMensagem: "",
                              })
                            }
                            }
                          >
                            <option value="">Selecione</option>
                            <option value="cpf">CPF</option>
                            <option value="cnpj">CNPJ</option>
                          </select>
                        </div>

                        <div className="col-2">
                          <label
                            htmlFor="cpfoucnpj"
                            className="form-label"
                          >
                            CPF/CNPJ Proprietário
                          </label>

                          <input
                            id="cpfoucnpj"
                            type="text"
                            maxLength={proprietario.tipo === "cpf" ? 14 : 18}
                            value={proprietario.cpfCnpj}
                            onBlur={handleBlurProprietario}
                            onChange={(e) => {
                              setProprietario({
                                ...proprietario,
                                cpfCnpj: aplicarMascaraCpfCnpj(
                                  e.target.value,
                                  proprietario.tipo
                                ),
                              })
                              }
                            }
                            className="form-control"
                            placeholder={
                              proprietario.tipo === "cpf"
                                ? "000.000.000-00"
                                : "00.000.000/0000-00"
                            }
                          />
                        </div>

                        <div class="col-2">
                          <label
                            htmlFor="nomeProprietario"
                            className="form-label"
                          >
                            Nome Proprietário
                          </label>
                          <input
                            disabled={view}
                            type="text"
                            maxLength={50}
                            onChange={(e) => {
                              const letras = e.target.value.replace(
                                /[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g,
                                ""
                              );
                              setProprietario({
                                ...proprietario,
                                nome: letras,
                              });
                            }}
                            value={proprietario.nome}
                            className="form-control"
                            id="nomeProprietario"
                          />
                        </div>
                        <div class="row">
                          <div class="col-2"></div>
                          <div class="col-2"></div>
                          <div style={{ marginTop: "5px" }} class="col-2">
                            <input
                              disabled={view}
                              type="checkbox"
                              name="VeiculoProprio"
                              id="veiculoProprio"
                              checked={veiculoProprio}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              style={{ marginLeft: "5px" }}
                              htmlFor="veiculoProprio"
                              className="form-label"
                            >
                              Veículo Próprio
                            </label>
                          </div>
                        </div>
                      </div>
                    </TabPane>

                    {Array.isArray(reboques) &&
                      reboques
                        .filter((r) => r && typeof r === "object")
                        .map((reboque, index) => (
                          <TabPane
                            key={`reboque-${index}`}
                            tab={
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 8,
                                }}
                              >
                                {`Veículos Reboque ${index + 1}`}
                                {reboques.length > 1 && (
                                  <IconButton
                                    disabled={view}
                                    aria-label="Excluir reboque"
                                    size="small"
                                    color="error"
                                    style={{ marginLeft: 4 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removerReboque(index);
                                    }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </span>
                            }
                          >
                            <Cards>
                              <div className="row">
                                <div className="col-2">
                                  <label
                                    htmlFor={`placaReboque${index}`}
                                    className="form-label"
                                  >
                                    Placa Reboque
                                  </label>
                                  <InputMask
                                    disabled={view}
                                    mask="aaa-9*99"
                                    maskChar=""
                                    value={reboque.placaReboque}
                                    onChange={(e) =>
                                      handleChangeReboques(
                                        index,
                                        "placaReboque",
                                        e.target.value.toUpperCase()
                                      )
                                    }
                                  >
                                    {(inputProps) => (
                                      <input
                                        disabled={view}
                                        {...inputProps}
                                        className="form-control"
                                        id={`placaReboque${index}`}
                                        placeholder="ABC-1234"
                                      />
                                    )}
                                  </InputMask>
                                </div>
                                <div className="col-2">
                                  <label
                                    htmlFor={`renavamReboque${index}`}
                                    className="form-label"
                                  >
                                    Renavam Reboque
                                  </label>
                                  <input
                                    disabled={view}
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    className="form-control"
                                    id={`renavamReboque${index}`}
                                    value={reboque.renavamReboque}
                                    onChange={(e) => {
                                      const onlyNumbers =
                                        e.target.value.replace(/\D/g, "");
                                      handleChangeReboques(
                                        index,
                                        "renavamReboque",
                                        onlyNumbers
                                      );
                                    }}
                                    maxLength={11}
                                    placeholder="Somente números"
                                  />
                                  {reboque.renavamReboque.length > 11 && (
                                    <div className="fade-message">
                                      <small className="text-danger">
                                        O RENAVAM não pode ter mais de 11
                                        dígitos.
                                      </small>
                                    </div>
                                  )}
                                </div>
                                <div style={{ width: "20%" }}>
                                  <label
                                    htmlFor={`ufReboque${index}`}
                                    className="form-label"
                                  >
                                    UF Reboque
                                  </label>
                                  <select
                                    disabled={view}
                                    className="form-select"
                                    id={`ufReboque${index}`}
                                    value={reboque.ufReboque || ""}
                                    onChange={(e) =>
                                      handleChangeReboques(
                                        index,
                                        "ufReboque",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">
                                      Selecione um estado
                                    </option>
                                    {statesUF.map((state) => (
                                      <option
                                        key={state.value}
                                        value={state.value}
                                      >
                                        {state.value} - {state.label}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-2">
                                  <div>
                                    <label
                                      tabIndex={"0"}
                                      id="cnhReboque"
                                      htmlFor="originStateInitial"
                                      className="form-label"
                                    >
                                      CRLV Reboque{" "}
                                    </label>
                                  </div>
                                  {reboque.cnhReboque ? (
                                    <ul
                                      style={{
                                        listStyle: "none",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                    >
                                      <li
                                        style={{
                                          background: "#f8f9fa",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: "8px",
                                          padding: "2px 3px",
                                          marginBottom: "4px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.05)",
                                          transition: "all 0.3s ease",
                                        }}
                                      >
                                        <a
                                          href={reboque.cnhReboque}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            width: "100%",
                                            textDecoration: "none",
                                            color: "#007bff",
                                            fontWeight: 500,
                                            marginRight: 10,
                                            padding: "6px 14px",
                                            borderRadius: 6,
                                            background:
                                              "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)",
                                            // border: "1px solid #b6d4fe",
                                            boxShadow:
                                              "0 2px 8px rgba(0,123,255,0.08)",
                                            transition:
                                              "background 0.2s, color 0.2s, box-shadow 0.2s",
                                            display: "inline-block",
                                            cursor: "pointer",
                                          }}
                                          onMouseOver={(e) => {
                                            e.currentTarget.style.background =
                                              "#d0e7ff";
                                            e.currentTarget.style.color =
                                              "#0056b3";
                                            e.currentTarget.style.boxShadow =
                                              "0 4px 12px rgba(0,123,255,0.15)";
                                          }}
                                          onMouseOut={(e) => {
                                            e.currentTarget.style.background =
                                              "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)";
                                            e.currentTarget.style.color =
                                              "#007bff";
                                            e.currentTarget.style.boxShadow =
                                              "0 2px 8px rgba(0,123,255,0.08)";
                                          }}
                                        >
                                          CRLV Reboque
                                        </a>
                                        <IconButton
                                          disabled={view}
                                          aria-label="Excluir"
                                          size="small"
                                          color="error"
                                          onClick={async () => {
                                            try {
                                              await handleDelete(
                                                reboque.cnhReboque
                                              );
                                              handleChangeReboques(
                                                index,
                                                "cnhReboque",
                                                ""
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Erro ao excluir:",
                                                error
                                              );
                                            }
                                          }}
                                          sx={{
                                            "&:hover": {
                                              backgroundColor:
                                                "rgba(211, 47, 47, 0.1)",
                                              transform: "scale(1.1)",
                                            },
                                            transition: "all 0.2s ease-in-out",
                                            padding: "4px",
                                            borderRadius: "50%",
                                            border: "1px solid transparent",
                                            "&:focus": {
                                              outline: "none",
                                              border: "1px solid #d32f2f",
                                            },
                                          }}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </li>
                                    </ul>
                                  ) : (
                                    <Button
                                      disabled={view}
                                      variant="outlined"
                                      onClick={(e) => {
                                        handleClickOpen();
                                        setOrigem(`CNH Verso ${index}`);
                                      }}
                                    >
                                      Importar Documento
                                    </Button>
                                  )}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-4">
                                  <label
                                    htmlFor={`descricaoReboque${index}`}
                                    className="form-label"
                                  >
                                    Descrição Reboque
                                  </label>

                                  <input
                                    disabled={view}
                                    type="text"
                                    maxLength={200}
                                    onChange={(e) =>
                                      handleChangeReboques(
                                        index,
                                        "descricaoReboque",
                                        e.target.value
                                      )
                                    }
                                    value={reboque.descricaoReboque}
                                    className="form-control"
                                    id={`descricaoReboque${index}`}
                                  />
                                </div>

                                <small className="text-muted">
                                  {reboque.descricaoReboque?.length || 0}/200
                                  caracteres
                                </small>
                              </div>

                              <div className="row">
                                <div className="col-2">
                                  <label
                                    htmlFor={`RNTRCReboque${index}`}
                                    className="form-label"
                                  >
                                    RNTRC Reboque
                                  </label>
                                  <input
                                    disabled={view}
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    className="form-control"
                                    id={`RNTRCReboque${index}`}
                                    value={reboque.rntrcReboque}
                                    onChange={(e) => {
                                      let valor = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      );
                                      handleChangeReboques(
                                        index,
                                        "rntrcReboque",
                                        valor
                                      );
                                    }}
                                    maxLength={8}
                                    placeholder="Apenas números"
                                  />
                                  {reboque.rntrcReboque &&
                                    (reboque.rntrcReboque[0] === "0"
                                      ? reboque.rntrcReboque.length - 1
                                      : reboque.rntrcReboque.length) > 8 && (
                                      <div className="fade-message">
                                        <small className="text-danger">
                                          O RNTRC deve conter no máximo 8
                                          dígitos válidos!
                                        </small>
                                      </div>
                                    )}
                                </div>
                                <div className="col-2">
                                  <label
                                    htmlFor={`tipoRNTRCReboque${index}`}
                                    className="form-label"
                                  >
                                    Tipo RNTRC Reboque
                                  </label>
                                  <select
                                    disabled={view}
                                    className="form-select"
                                    id={`tipoRNTRCReboque${index}`}
                                    value={reboque.tipoRNTRCReboque}
                                    onChange={(e) =>
                                      handleChangeReboques(
                                        index,
                                        "tipoRNTRCReboque",
                                        e.target.value
                                      )
                                    }
                                    aria-label=""
                                  >
                                    <option defaultValue="">Selecione</option>
                                    <option value="tac">TAC</option>
                                    <option value="etc">ETC</option>
                                    <option value="ctc">CTC</option>
                                  </select>
                                </div>
                                <div className="col-2">
                                  <label
                                    htmlFor={`TipoCarroceriaReboque${index}`}
                                    className="form-label"
                                  >
                                    Tipo Carroceria Reboque
                                  </label>
                                  <select
                                    disabled={view}
                                    className="form-select"
                                    id={`TipoCarroceriaReboque${index}`}
                                    value={reboque.TipoCarroceriaReboque}
                                    onChange={(e) =>
                                      handleChangeReboques(
                                        index,
                                        "TipoCarroceriaReboque",
                                        e.target.value
                                      )
                                    }
                                    aria-label=""
                                  >
                                    <option defaultValue="">Selecione</option>
                                    <option value="BOBINEIRA">BOBINEIRA</option>
                                    <option value="GRADE BAIXA">
                                      GRADE BAIXA
                                    </option>
                                    <option value="BAÚSECO">BAÚSECO</option>
                                    <option value="BAÚ FRIGORIFICO">
                                      BAÚ FRIGORIFICO
                                    </option>
                                    <option value="ABERTO">ABERTO</option>
                                    <option value="BAÚ">BAÚ</option>
                                    <option value="DOLLY">DOLLY</option>
                                    <option value="GRANELEIRO">
                                      GRANELEIRO
                                    </option>
                                    <option value="SIDER">SIDER</option>
                                    <option value="PRANCHA">PRANCHA</option>
                                    <option value="TANQUE">TANQUE</option>
                                    <option value="CAÇAMBA">CAÇAMBA</option>
                                    <option value="PORTA CONTEINER">
                                      PORTA CONTEINER
                                    </option>
                                    <option value="CILO">CILO</option>
                                    <option value="CEGONHA">CEGONHA</option>
                                  </select>
                                </div>

                                <div className="col-2">
                                  <div>
                                    <label
                                      tabIndex={"0"}
                                      id={`anttReboque%{index}`}
                                      htmlFor="originStateInitial"
                                      className="form-label"
                                    >
                                      ANTT Reboque{" "}
                                    </label>
                                  </div>
                                  {reboque.anttReboque ? (
                                    <ul
                                      style={{
                                        listStyle: "none",
                                        padding: 0,
                                        margin: 0,
                                      }}
                                    >
                                      <li
                                        style={{
                                          background: "#f8f9fa",
                                          border: "1px solid #e0e0e0",
                                          borderRadius: "8px",
                                          padding: "2px 3px",
                                          marginBottom: "4px",
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.05)",
                                          transition: "all 0.3s ease",
                                        }}
                                      >
                                        <a
                                          href={reboque.anttReboque}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            width: "100%",
                                            textDecoration: "none",
                                            color: "#007bff",
                                            fontWeight: 500,
                                            marginRight: 10,
                                            padding: "6px 14px",
                                            borderRadius: 6,
                                            background:
                                              "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)",
                                            // border: "1px solid #b6d4fe",
                                            boxShadow:
                                              "0 2px 8px rgba(0,123,255,0.08)",
                                            transition:
                                              "background 0.2s, color 0.2s, box-shadow 0.2s",
                                            display: "inline-block",
                                            cursor: "pointer",
                                          }}
                                          onMouseOver={(e) => {
                                            e.currentTarget.style.background =
                                              "#d0e7ff";
                                            e.currentTarget.style.color =
                                              "#0056b3";
                                            e.currentTarget.style.boxShadow =
                                              "0 4px 12px rgba(0,123,255,0.15)";
                                          }}
                                          onMouseOut={(e) => {
                                            e.currentTarget.style.background =
                                              "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)";
                                            e.currentTarget.style.color =
                                              "#007bff";
                                            e.currentTarget.style.boxShadow =
                                              "0 2px 8px rgba(0,123,255,0.08)";
                                          }}
                                        >
                                          ANTT Reboque
                                        </a>
                                        <IconButton
                                          disabled={view}
                                          aria-label="Excluir"
                                          size="small"
                                          color="error"
                                          onClick={async () => {
                                            try {
                                              await handleDelete(
                                                reboque.anttReboque
                                              );
                                              handleChangeReboques(
                                                index,
                                                "anttReboque",
                                                ""
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Erro ao excluir:",
                                                error
                                              );
                                            }
                                          }}
                                          sx={{
                                            "&:hover": {
                                              backgroundColor:
                                                "rgba(211, 47, 47, 0.1)",
                                              transform: "scale(1.1)",
                                            },
                                            transition: "all 0.2s ease-in-out",
                                            padding: "4px",
                                            borderRadius: "50%",
                                            border: "1px solid transparent",
                                            "&:focus": {
                                              outline: "none",
                                              border: "1px solid #d32f2f",
                                            },
                                          }}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </li>
                                    </ul>
                                  ) : (
                                    <Button
                                      disabled={view}
                                      variant="outlined"
                                      onClick={(e) => {
                                        handleClickOpen();
                                        setOrigem(`Antt Reboque ${index}`);
                                      }}
                                    >
                                      Importar Documento
                                    </Button>
                                  )}
                                </div>
                              </div>

                              <div class="row">
                                <div className="col-2">
                                  <label
                                    htmlFor="tipoProprietario"
                                    className="form-label"
                                  >
                                    Tipo Proprietário Reboque
                                  </label>

                                  <select
                                    disabled={view}
                                    className="form-select"
                                    value={
                                      reboque.tipoProprietarioReboque || ""
                                    }
                                    onChange={(e) => {
                                      const novoValor = e.target.value;

                                      setReboques((prev) => {
                                        const copia = [...prev];
                                        copia[index].tipoProprietarioReboque =
                                          novoValor;
                                        copia[index].cpfoucnpjReboque = ""; // limpa somente deste reboque
                                        return copia;
                                      });
                                    }}
                                  >
                                    <option value="">Selecione</option>
                                    <option value="cpf">CPF</option>
                                    <option value="cnpj">CNPJ</option>
                                  </select>
                                </div>

                                <div className="col-2">
                                  <label
                                    htmlFor="CPF_CNPJProprietario"
                                    className="form-label"
                                  >
                                    CPF/CNPJ Proprietário Reboque
                                  </label>

                                  <input
                                    type="text"
                                    maxLength={18}
                                    value={reboque.cpfoucnpjReboque || ""}
                                    placeholder={
                                      reboque.tipoProprietarioReboque === "cpf"
                                        ? "000.000.000-00"
                                        : "00.000.000/0000-00"
                                    }
                                    onChange={(e) => {
                                      const valor = e.target.value;

                                      const formatted = formatCpfOuCnpj(
                                        valor,
                                        reboque.tipoProprietarioReboque
                                      );

                                      setReboques((prev) => {
                                        const copia = [...prev];
                                        copia[index].cpfoucnpjReboque =
                                          formatted;
                                        return copia;
                                      });
                                    }}
                                    className="form-control"
                                  />

                                  {erroMensagem && (
                                    <div className="fade-message">
                                      <small className="text-danger">
                                        {erroMensagem}
                                      </small>
                                    </div>
                                  )}

                                  {erroNomeCpfIgual === true && (
                                    <div className="fade-message">
                                      <small className="text-danger">
                                        O CPF é igual ao do motorista! Selecione
                                        a opção Veículo Próprio!
                                      </small>
                                    </div>
                                  )}
                                </div>

                                <div class="col-2">
                                  <label
                                    htmlFor="nomeProprietario"
                                    className="form-label"
                                  >
                                    Nome Proprietário Reboque
                                  </label>

                                  <input
                                    type="text"
                                    maxLength={50}
                                    value={
                                      reboque.nomeProprietarioReboque || ""
                                    }
                                    onChange={(e) => {
                                      const somenteLetras =
                                        e.target.value.replace(
                                          /[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g,
                                          ""
                                        );

                                      setReboques((prev) => {
                                        const copia = [...prev];
                                        copia[index].nomeProprietarioReboque =
                                          somenteLetras;
                                        return copia;
                                      });
                                    }}
                                    className="form-control"
                                  />

                                  {erroNomeCpfIgual === true && (
                                    <div className="fade-message">
                                      <small className="text-danger">
                                        O nome é igual ao do motorista!
                                        Selecione a opção Veículo Proprio!
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-2"></div>
                                <div className="col-2"></div>
                                <div style={{ marginTop: "5px", width: "18%" }}>
                                  <input
                                    disabled={view}
                                    type="checkbox"
                                    name={`veiculoProprioReboque${index}`}
                                    id={`veiculoProprioReboque${index}`}
                                    checked={reboque.veiculoProprioReboque}
                                    onChange={(e) =>
                                      handleChangeReboques(
                                        index,
                                        "veiculoProprioReboque",
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <label
                                    style={{ marginLeft: "10px" }}
                                    htmlFor={`veiculoProprioReboque${index}`}
                                    className="form-label"
                                  >
                                    Veículo Próprio Reboque
                                  </label>
                                </div>
                                <div
                                  style={{ marginTop: "5px" }}
                                  className="col-2"
                                >
                                  <span
                                    style={{
                                      color: "#007bff",
                                      cursor: "pointer",
                                      fontSize: "14px",
                                      fontWeight: "normal",
                                    }}
                                    onClick={view ? null : adicionarReboque}
                                  >
                                    + Adicionar Reboque
                                  </span>
                                </div>
                              </div>
                            </Cards>
                          </TabPane>
                        ))}

                    <TabPane tab="Endereço" key="4">
                      <div className="row">
                        <div className="row">
                          <div className="col-2">
                            <label htmlFor="cnpjDriver" className="form-label">
                              CEP
                            </label>
                            <InputMask
                              disabled={view}
                              mask="99999-999"
                              className="form-control"
                              onChange={(e) => {
                                buscarCep(e.target.value);
                                setCep(e.target.value);
                              }}
                              value={cep && cep}
                              placeholder="99999-999"
                            />
                          </div>

                          <div className="col-md-3">
                            <label
                              htmlFor="streetDriver"
                              className="form-label"
                            >
                              Logradouro
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              maxLength={100}
                              onChange={(e) => setStreet(e.target.value)}
                              value={street && street}
                              className="form-control"
                              id="streetDriver"
                            />
                          </div>

                          <div className="col-md-2">
                            <div>
                              <label
                                tabIndex={"0"}
                                id="comprovanteEndereco"
                                htmlFor="originStateInitial"
                                className="form-label"
                              >
                                Comprovante Endereço{" "}
                              </label>
                            </div>
                            {comprovanteEndereco ? (
                              <ul
                                style={{
                                  listStyle: "none",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                <li
                                  style={{
                                    background: "#f8f9fa",
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "8px",
                                    padding: "2px 3px",
                                    marginBottom: "4px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  <a
                                    href={comprovanteEndereco}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      width: "100%",
                                      textDecoration: "none",
                                      color: "#007bff",
                                      fontWeight: 500,
                                      marginRight: 10,
                                      padding: "6px 14px",
                                      borderRadius: 6,
                                      background:
                                        "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)",
                                      boxShadow:
                                        "0 2px 8px rgba(0,123,255,0.08)",
                                      transition:
                                        "background 0.2s, color 0.2s, box-shadow 0.2s",
                                      display: "inline-block",
                                      cursor: "pointer",
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.background =
                                        "#d0e7ff";
                                      e.currentTarget.style.color = "#0056b3";
                                      e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(0,123,255,0.15)";
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.background =
                                        "linear-gradient(90deg, #e3f0ff 0%, #f6faff 100%)";
                                      e.currentTarget.style.color = "#007bff";
                                      e.currentTarget.style.boxShadow =
                                        "0 2px 8px rgba(0,123,255,0.08)";
                                    }}
                                  >
                                    Comprovante Endereço
                                  </a>
                                  <IconButton
                                    disabled={view}
                                    aria-label="Excluir"
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                      handleDelete(comprovanteEndereco);
                                      setComprovanteEndereco(null);
                                    }}
                                    sx={{
                                      "&:hover": {
                                        backgroundColor:
                                          "rgba(211, 47, 47, 0.1)",
                                        transform: "scale(1.1)",
                                      },
                                      transition: "all 0.2s ease-in-out",
                                      padding: "4px",
                                      borderRadius: "50%",
                                      border: "1px solid transparent",
                                      "&:focus": {
                                        outline: "none",
                                        border: "1px solid #d32f2f",
                                      },
                                    }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </li>
                              </ul>
                            ) : (
                              <Button
                                disabled={view}
                                className="col-md-12"
                                variant="outlined"
                                onClick={() => {
                                  handleClickOpen();
                                  setOrigem("Comprovante Endereco");
                                }}
                              >
                                Importar Documento
                              </Button>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-1">
                            <label
                              htmlFor="numberDriver"
                              className="form-label"
                            >
                              Número
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              maxLength={10}
                              onChange={(e) => setNumber(e.target.value)}
                              value={number && number}
                              className="form-control"
                              id="numberDriver"
                              placeholder=""
                            />
                          </div>

                          <div className="col-md-2">
                            <label
                              htmlFor="districtDriver"
                              className="form-label"
                            >
                              Bairro
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              maxLength={80}
                              onChange={(e) => setDistrict(e.target.value)}
                              value={district && district}
                              className="form-control"
                              id="districtDriver"
                            />
                          </div>

                          <div className="col-2">
                            <label htmlFor="cityDriver" className="form-label">
                              Cidade
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => {
                                setCity(e.target.value);
                              }}
                              value={city && city}
                              maxLength={50}
                              className="form-control"
                              id="cityDriver"
                              placeholder=""
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-2">
                            <label
                              htmlFor="originStateInitial"
                              className="form-label"
                            >
                              Estado
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setState(e.target.value)}
                              value={state && state}
                              className="form-control"
                              id="stateDriver"
                            />
                          </div>
                          <div className="col-md-3">
                            <label
                              htmlFor="complementoEndereco"
                              className="form-label"
                            >
                              Complemento
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              maxLength={50}
                              onChange={(e) =>
                                setComplementoEndereco(e.target.value)
                              }
                              value={complementoEndereco && complementoEndereco}
                              className="form-control"
                              id="complementoEndereco"
                            />
                          </div>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tab="Contato" key="5">
                      <div className="row">
                        <div className="col-12">
                          <h4 className="mb-3">Contatos de parentes</h4>
                        </div>

                        {Array.isArray(contacts) &&
                          contacts
                            .filter((r) => r && typeof r === "object")
                            .map((contato, index) => (
                              <div className="row mb-2" key={index}>
                                <div className="col-md-4">
                                  <label
                                    htmlFor="nameKinships2"
                                    className="form-label"
                                  >
                                    Nome
                                  </label>
                                  <input
                                    disabled={view}
                                    type="text"
                                    maxLength={50}
                                    className="form-control"
                                    placeholder="Nome"
                                    value={contato.name || ""}
                                    onChange={(e) =>
                                      handleChangeContacts(
                                        index,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-md-2">
                                  <label
                                    htmlFor="documentAnttFrontImg"
                                    className="form-label"
                                  >
                                    Contato
                                  </label>
                                  <InputMask
                                    disabled={view}
                                    mask="(99) 99999-9999"
                                    className="form-control"
                                    placeholder="(99) 99999-9999"
                                    value={contato.contact || ""}
                                    onChange={(e) =>
                                      handleChangeContacts(
                                        index,
                                        "contact",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-md-2">
                                  <label
                                    htmlFor="fullName"
                                    className="form-label"
                                  >
                                    Grau
                                  </label>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                    }}
                                  >
                                    <select
                                      disabled={view}
                                      className="form-select"
                                      value={contato.degree || ""}
                                      onChange={(e) =>
                                        handleChangeContacts(
                                          index,
                                          "degree",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="">Selecione</option>
                                      <option value="Mãe/Pai">Mãe/Pai</option>
                                      <option value="Esposa/Marido">
                                        Esposa/Marido
                                      </option>
                                      <option value="Filha/filho">
                                        Filha/filho
                                      </option>
                                      <option value="Irmã/Irmão">
                                        Irmã/Irmão
                                      </option>
                                      <option value="Tia/Tio">Tia/Tio</option>
                                      <option value="Prima/Primo">
                                        Prima/Primo
                                      </option>
                                    </select>
                                    {contacts.length > 1 && (
                                      <IconButton
                                        disabled={view}
                                        aria-label="Excluir Contato"
                                        size="small"
                                        color="error"
                                        style={{ marginLeft: 4 }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          removerContact(index);
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                        <div style={{ marginTop: "5px" }} className="col-2">
                          <span
                            style={{
                              color: "#007bff",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "normal",
                            }}
                            onClick={view ? null : adicionarContact}
                          >
                            + Adicionar Contato
                          </span>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <h4 className="mb-3">Contato profissional</h4>
                        </div>

                        {Array.isArray(contactsProfessional) &&
                          contactsProfessional
                            .filter((r) => r && typeof r === "object")
                            .map((contato, index) => (
                              <div className="row mb-2" key={index}>
                                <div className="col-4">
                                  <label
                                    htmlFor={`nameProfessional${index}`}
                                    className="form-label"
                                  >
                                    Nome
                                  </label>
                                  <input
                                    disabled={view}
                                    type="text"
                                    maxLength={50}
                                    onChange={(e) =>
                                      handleChangeContactsProfessional(
                                        index,
                                        "nameProfessional",
                                        e.target.value
                                      )
                                    }
                                    value={contato.nameProfessional || ""}
                                    className="form-control"
                                    id={`nameProfessional${index}`}
                                    placeholder=""
                                  />
                                </div>

                                <div className="col-3">
                                  <label
                                    htmlFor={`contactProfessional${index}`}
                                    className="form-label"
                                  >
                                    Contato
                                  </label>
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 8,
                                    }}
                                  >
                                    <InputMask
                                      disabled={view}
                                      mask="(99) 99999-9999"
                                      className="form-control"
                                      onChange={(e) =>
                                        handleChangeContactsProfessional(
                                          index,
                                          "contactProfessional",
                                          e.target.value
                                        )
                                      }
                                      value={contato.contactProfessional || ""}
                                      placeholder="(99) 99999-9999"
                                      id={`contactProfessional${index}`}
                                    />
                                    {contactsProfessional.length > 1 && (
                                      <IconButton
                                        disabled={view}
                                        aria-label="Excluir Contato"
                                        size="small"
                                        color="error"
                                        style={{ marginLeft: 4 }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          removerContactProfessional(index);
                                        }}
                                      >
                                        <DeleteIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                        <div className="col-2"></div>
                        <div style={{ marginTop: "5px" }} className="col-2">
                          <span
                            style={{
                              color: "#007bff",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "normal",
                            }}
                            onClick={view ? null : adicionarContactProfessional}
                          >
                            + Adicionar Contato Profissional
                          </span>
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tab="Dados bancários" key="6">
                      <div className="row">
                        <div className="row">
                          <div className="row">
                            <div className="row">
                              <div className="col-3">
                                <label
                                  htmlFor="bankName"
                                  className="form-label"
                                >
                                  Nome do banco
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  maxLength={60}
                                  onChange={(e) =>
                                    setBankName(apenasLetras(e.target.value))
                                  }
                                  value={bankName || ""}
                                  className="form-control"
                                  id="bankName"
                                />
                              </div>

                              <div className="col-1">
                                <label htmlFor="code" className="form-label">
                                  Código
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  maxLength={3}
                                  onChange={(e) =>
                                    setCode(apenasNumeros(e.target.value))
                                  }
                                  value={code || ""}
                                  className="form-control"
                                  id="code"
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-md-2">
                                <label htmlFor="agency" className="form-label">
                                  Agência
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  maxLength={6}
                                  onChange={(e) =>
                                    setAgency(formatarAgencia(e.target.value))
                                  }
                                  value={agency || ""}
                                  className="form-control"
                                  id="agency"
                                />
                              </div>

                              <div className="col-3">
                                <label
                                  htmlFor="accountNumber"
                                  className="form-label"
                                >
                                  Número da conta
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  maxLength={12}
                                  onChange={(e) =>
                                    setAccountNumber(
                                      apenasNumeros(e.target.value)
                                    )
                                  }
                                  value={accountNumber || ""}
                                  className="form-control"
                                  id="accountNumber"
                                />
                              </div>

                              <div className="col-1">
                                <label
                                  htmlFor="accountDigit"
                                  className="form-label"
                                >
                                  Dígito
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  maxLength={2}
                                  onChange={(e) =>
                                    setAccountDigit(
                                      apenasNumeros(e.target.value)
                                    )
                                  }
                                  value={accountDigit || ""}
                                  className="form-control"
                                  id="accountDigit"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                            <label
                              htmlFor="holderAccount"
                              className="form-label"
                            >
                              Propríetário da conta
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setHolderAccount(e.target.value)}
                              value={holderAccount && holderAccount}
                              className="form-control"
                              id="holderAccount"
                            />
                          </div>

                          <div className="col-md-3">
                            <label htmlFor="tipoPix" className="form-label">
                              Tipo de Chave PIX
                            </label>
                            <select
                              disabled={view}
                              id="tipoPix"
                              className="form-control"
                              value={tipo}
                              onChange={(e) => {
                                setTipo(e.target.value);
                                setPix("");
                                setErro("");
                              }}
                            >
                              <option value="">Selecione</option>
                              <option value="CPF">CPF</option>
                              <option value="CNPJ">CNPJ</option>
                              <option value="Celular">Celular</option>
                              <option value="E-Mail">E-Mail</option>
                              <option value="Chave Aleatória">
                                Chave Aleatória
                              </option>
                            </select>

                            <label htmlFor="pix" className="form-label mt-2">
                              PIX
                            </label>
                            <input
                              type="text"
                              id="pix"
                              className="form-control"
                              placeholder="Insira a chave PIX"
                              value={pix}
                              disabled={!tipo || view}
                              onChange={(e) => {
                                let valor = e.target.value.replace(/\D/g, "");
                                let erroMsg = "";

                                switch (tipo) {
                                  case "CPF":
                                    valor = e.target.value;
                                    valor = valor

                                      .replace(/\D/g, "")
                                      .replace(/^(\d{3})(\d)/, "$1.$2")
                                      .replace(
                                        /^(\d{3})\.(\d{3})(\d)/,
                                        "$1.$2.$3"
                                      )
                                      .replace(/\.(\d{3})(\d{1,2}).*/, ".$1-$2")
                                      .slice(0, 14);

                                    const CPFValido = valor.length === 14;
                                    if (!CPFValido && valor.length > 0) {
                                      erroMsg = "Número de CPF incompleto.";
                                    }
                                    break;
                                  case "CNPJ":
                                    valor = e.target.value;
                                    valor = valor
                                      .replace(/^(\d{2})(\d)/, "$1.$2")
                                      .replace(
                                        /^(\d{2})\.(\d{3})(\d)/,
                                        "$1.$2.$3"
                                      )
                                      .replace(/\.(\d{3})(\d)/, ".$1/$2")
                                      .replace(/(\d{4})(\d)/, "$1-$2")
                                      .slice(0, 18);
                                    const CNPJValido = valor.length === 18;
                                    if (!CNPJValido && valor.length > 0) {
                                      erroMsg = "Número de CPF incompleto.";
                                    }

                                    break;
                                  case "Celular":
                                    valor = e.target.value;
                                    valor = valor.replace(/\D/g, "");
                                    valor = valor

                                      .replace(/^(\d{2})(\d)/g, "($1) $2")
                                      .replace(/(\d{5})(\d{4}).*/, "$1-$2");
                                    const celularValido = valor.length === 15;

                                    if (!celularValido && valor.length > 0) {
                                      erroMsg =
                                        "Número de celular incompleto. Formato: (00) 00000-0000";
                                    }
                                    break;
                                  case "E-Mail":
                                    valor = e.target.value;
                                    const emailValido =
                                      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor);
                                    if (!emailValido && valor.length > 0)
                                      erroMsg = "E-mail inválido";
                                    break;
                                  case "Chave Aleatória":
                                    valor = e.target.value;

                                    // Remove tudo que não for hexadecimal (0-9, a-f)
                                    valor = valor
                                      .replace(/[^0-9a-fA-F]/g, "")
                                      .toLowerCase();

                                    // Formata incrementalmente como UUID: 8-4-4-4-12
                                    if (valor.length > 8 && valor.length <= 12)
                                      valor = valor.replace(
                                        /^([0-9a-f]{8})([0-9a-f]+)/,
                                        "$1-$2"
                                      );
                                    else if (
                                      valor.length > 12 &&
                                      valor.length <= 16
                                    )
                                      valor = valor.replace(
                                        /^([0-9a-f]{8})-?([0-9a-f]{4})([0-9a-f]+)/,
                                        "$1-$2-$3"
                                      );
                                    else if (
                                      valor.length > 16 &&
                                      valor.length <= 20
                                    )
                                      valor = valor.replace(
                                        /^([0-9a-f]{8})-?([0-9a-f]{4})-?([0-9a-f]{4})([0-9a-f]+)/,
                                        "$1-$2-$3-$4"
                                      );
                                    else if (valor.length > 20)
                                      valor = valor.replace(
                                        /^([0-9a-f]{8})-?([0-9a-f]{4})-?([0-9a-f]{4})-?([0-9a-f]{4})([0-9a-f]+)/,
                                        "$1-$2-$3-$4-$5"
                                      );

                                    // Limita o tamanho total (UUID = 36 caracteres)
                                    valor = valor.slice(0, 36);

                                    // Verifica se o formato completo é válido (UUID)
                                    const uuidValido =
                                      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
                                        valor
                                      );

                                    if (valor.length > 0 && !uuidValido) {
                                      erroMsg =
                                        "Chave PIX aleatória incompleta ou inválida.";
                                    } else {
                                      erroMsg = "";
                                    }

                                    break;
                                  default:
                                    break;
                                }

                                setPix(valor);
                                setErro(erroMsg);
                              }}
                            />

                            {erro && (
                              <small style={{ color: "red" }}>{erro}</small>
                            )}
                          </div>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </Card>
              {/* Footer */}
              <Footer style={{ textAlign: "center" }}>
                <div className="row">
                  <div className="col-md-2">
                    <label htmlFor="createdDriver" className="form-label">
                      Data de criação
                    </label>
                    <input
                      type="date"
                      onChange={(e) => setCreated(e.target.value)}
                      disabled={true}
                      value={created && created}
                      className="form-control"
                      id="createdDriver"
                    />
                  </div>

                  <div className="col-md-2">
                    <label htmlFor="originStateInitial" className="form-label">
                      Atualizacão app
                    </label>
                    <input
                      type="date"
                      onChange={(e) => setLastUpdated(e.target.value)}
                      disabled={true}
                      value={lastUpdated && lastUpdated}
                      className="form-control"
                      id="lastUpdatedDriver"
                    />
                  </div>

                  <div className="col-md-2">
                    <label
                      htmlFor="lastUpdatedBackOffice"
                      className="form-label"
                    >
                      BackOffice
                    </label>
                    <input
                      type="date"
                      onChange={(e) => setLastUpdatedBackOffice(e.target.value)}
                      disabled={true}
                      value={lastUpdatedBackOffice && lastUpdatedBackOffice}
                      className="form-control"
                      id="lastUpdatedBackOffice"
                    />
                  </div>
                  <div className="col-md-2">
                    <label htmlFor="dateRenovation" className="form-label">
                      Data renovação
                    </label>
                    <input
                      disabled={view}
                      type="date"
                      onChange={(e) => setDateRenovation(e.target.value)}
                      value={dateRenovation && dateRenovation}
                      className="form-control"
                      id="dateRenovation"
                    />
                  </div>

                  <hr className="my-4" />

                  <div className="container">
                    <div className="row">
                      <div className="col-5"></div>
                      <div className="col-5"></div>
                      <div className="col-2">
                        <div className="btn-class-cadastrar">
                          {carregando ? (
                            <div
                              className="spinner-border text-danger"
                              role="status"
                            >
                              <span className="visually-hidden ">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <button
                              disabled={
                                view ||
                                Object.values(erroForm).some(
                                  (err) => err.hasError
                                )
                              }
                              type="submit"
                              onClick={handleSave}
                              className="w-100 btn btn-primary btn-cadastrar"
                            >
                              {/* {"Salvar"} */}
                              {id ? "Atualizar" : "Cadastrar"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <Dialog
                      open={openDialog}
                      onClose={handleCloseDialog}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        <h1>
                          <i
                            class="fa fa-exclamation-triangle"
                            style={{ color: "#FEDE00" }}
                            aria-hidden="true"
                          ></i>
                          {title}
                        </h1>
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          <h6> {msg} </h6>
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <button
                          type="button"
                          onClick={handleCloseDialog}
                          className="btn btn-primary btn-cadastrar"
                        >
                          {" "}
                          Ok
                        </button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={showPerguntaVeiculoProprio}
                      onClose={() => setShowPerguntaVeiculoProprio(false)}
                      aria-labelledby="alert-dialog-title-veiculo-proprio"
                      aria-describedby="alert-dialog-description-veiculo-proprio"
                    >
                      <DialogTitle id="alert-dialog-title-veiculo-proprio">
                        <h1>
                          <i
                            className="fa fa-question-circle"
                            style={{ color: "#007bff" }}
                            aria-hidden="true"
                          ></i>
                          {" Veículo próprio?"}
                        </h1>
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description-veiculo-proprio">
                          <h6>
                            O nome e CPF do proprietário são iguais ao do
                            motorista. Deseja marcar como veículo próprio?
                          </h6>
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <button
                          type="button"
                          onClick={() => {
                            setVeiculoProprio(true);
                            setShowPerguntaVeiculoProprio(false);
                          }}
                          className="btn btn-success"
                        >
                          Sim
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setProprietario((prevState) => ({
                              ...prevState,
                              tipo: "",
                            }));
                            setProprietario((prevState) => ({
                              ...prevState,
                              cpfCnpj: "",
                            }));
                            setProprietario((prev) => ({
                              ...prev,
                              nome: "",
                            }));
                            setErroNomeCpfIgual(false);
                            setShowPerguntaVeiculoProprio(false);
                          }}
                          className="btn btn-danger"
                        >
                          Não
                        </button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </div>
              </Footer>
                </Spin>
              </Content>
            </Layout>

            <Snackbar
              open={shipperLinkSnackbar.open}
              autoHideDuration={8000}
              onClose={clearShipperLinkNotice}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Alert
                severity="info"
                variant="filled"
                onClose={clearShipperLinkNotice}
                sx={{ width: "100%" }}
              >
                {shipperLinkSnackbar.message}
              </Alert>
            </Snackbar>
            </>
          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default Driver;
